import {
    DeleteForeverOutlined as DeleteForeverOutlinedIcon,
    EditTwoTone as EditTwoToneIcon,
    FolderOpen as FolderOpenIcon,
    PostAdd as PostAddIcon,
    VisibilityOutlined as VisibilityOutlinedIcon
} from '@material-ui/icons';
import {
    AppBar, Box, Button, CardContent, Checkbox, colors, Dialog, DialogActions, DialogContent, DialogTitle,
    FormControl, FormControlLabel, FormGroup, FormLabel, IconButton, InputAdornment, InputLabel, Paper,
    Select, Switch, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tabs, TextField,
    Tooltip, Typography
} from '@material-ui/core';
import {
    ANAO, AREGIME_TRABALHO_MISTO, AREGIME_TRABALHO_NENHUM, AREGIME_TRABALHO_RODOVIARIO,
    AREGIME_TRABALHO_SEVERO, ASIM
} from '../../../consts';
import PropTypes from 'prop-types';
import api from '../../../services/api';
import React, { Component } from 'react';
import { isInvalidSelect } from 'lib/configUtils';
import ComboPadrao from 'views/Components/ComboPadrao';
import { validateField, formatCurrency, formatData } from 'lib/functions';
import AlertInformation from 'components/AlertInformation/AlertInformation';
import DeleteConfirmationModal from 'components/DeleteConfirmationModal/DeleteConfirmationModal';

function TabContainer(props) {
    return (
        <Typography component="div">
            {props.children}
        </Typography>
    );
};

TabContainer.propTypes = {
    children: PropTypes.node.isRequired
};

class VeiculoForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            openModalOpcionais: false,
            arquivoDocTS: null,
            arquivoDocRedeInterna: null,
            arquivoTS: null,
            arquivoRedeInterna: null,
            openConfirmRemoveSeguroTS: false,
            openConfirmRemoveSeguroRedeInterna: false,
            openConfirmRemoveDocumentoTS: false,
            openConfirmRemoveDocumentoRedeInterna: false,
            isNewRecord: false,
            isView: false,
            openModalOne: false,
            openModalTwo: false,
            openConfirmDeleteOpcional: false,
            opcionalASerExcluido: null,
            openConfirmDeleteDocumento: false,
            documentoASerExcluido: null,
            openModalDocumentos: false,
            documentoSelecionado: null,
            openConfirmRemoveOpcional: false,
            opcionalASerRemovido: null,
            activeTab: 0,
            documentosDisponiveis: [],
            documentosveiculo: [],
            eixos: [],
            tiposveiculo: [],
            combustiveis: [],
            modelosveiculo: [],
            fornecedores: [],
            projetos: [],
            opcionais: [],
            opcionaisveiculo: [],
            motoristas: [],
            fornecedorestransp: [],
            fornecedoresgeral: [],
            nomeMarcaAssociada: '',
            errors: {},
            documento: {
                descricao: '',
                vencimento: '',
                localdocts: '',
                localdocredeint: '',
                avisodiasantecedencia: '',
                descritivodoc: '',
                inativodoc: ANAO
            },
            veiculo: {
                codveiculo: '',
                nroveiculo: '',
                codtipoveiculo: '',
                codmodeloveiculo: '',
                descritivo: '',
                motivomanut: '',
                obsseguro: '',
                localdocsegts: '',
                localdocsegredeint: '',
                kmatual: '',
                inativo: ANAO
            },
            opcional: {
                codopcionalveiculo: 0,
                descopcionalveiculo: '',
                inativoopc: ANAO
            },
            schemaVeiculo: {
                nroveiculo: {
                    presence: { allowEmpty: false, message: 'Número do veículo obrigatório' },
                    length: { maximum: 64 },
                    type: 'string'
                },
                codtipoveiculo: {
                    presence: { allowEmpty: false, message: 'Tipo de veículo obrigatório' },
                    length: { maximum: 64 },
                    type: 'integer'
                },
                codfornecedorveiculo: {
                    presence: { allowEmpty: false, message: 'Fornecedor do veículo obrigatório' },
                    length: { maximum: 64 },
                    type: 'integer'
                }
            },
            schemaDocumento: {
                descricao: {
                    presence: { allowEmpty: false, message: 'Descrição do documento obrigatória' },
                    length: { maximum: 64 },
                    type: 'string'
                }
            },
            schemaOpcional: {
                descopcionalveiculo: {
                    presence: { allowEmpty: false, message: 'Descrição do opcional obrigatória' },
                    length: { maximum: 64 },
                    type: 'string'
                }
            }
        };
        this.inputFileTSRef = React.createRef();
        this.inputFileRedeInternaRef = React.createRef();
    };

    /* Console para ComboPadrao */
    logComboMatch = (label, list, fieldId, selectedValue) => {
        const item = (list || []).find(i => String(i?.[fieldId]) === String(selectedValue));
        console.log(`[VeiculoForm] ${label} - selectedValue:`, selectedValue, '| item encontrado =>', item);
    };

    /* Lista opcionais já vinculados ao veículo */
    listaOpcionais = async (codveiculo) => {
        if (!codveiculo) return;

        try {
            const response = await api.get(`/opcionaisdoveiculo/${codveiculo}`);
            this.setState({
                opcionaisveiculo: Array.isArray(response.data) ? response.data.map(opcional => ({
                    ...opcional,
                    inativoopc: opcional.inativoopc ?? opcional.inativo ?? ANAO
                })) : []
            });
        } catch (error) {
            console.error('Erro ao buscar opcionais do veículo:', error);
            this.handleOpenAlert('Erro ao listar opcionais do veículo!');
        }
    };

    /* Lista documentos na grid */
    listaDocumentos = async (codveiculoParam) => {
        const { veiculo } = this.state;
        const codveiculo = codveiculoParam || veiculo.codveiculo;

        if (!codveiculo) return;

        try {
            const response = await api.get(`/docveiculo?codveiculo=${codveiculo}`);
            this.setState({
                documentosveiculo: Array.isArray(response.data?.data) ? response.data.data : []
            });
        } catch (error) {
            console.error('Erro ao buscar documentos do veículo:', error);
            this.handleOpenAlert('Erro ao listar documentos do veículo!');
        }
    };

    async componentDidMount() {
        // carrega informações formulário
        const { codveiculo, id } = this.props.match.params;
        const routeId = id || codveiculo;
        const { location } = this.props;
        const { veiculo } = this.state;
        const currentPath = location.pathname;

        console.log('[VeiculoForm] componentDidMount');
        console.log('[VeiculoForm] match.params:', this.props.match.params);
        console.log('[VeiculoForm] routeId:', routeId);
        console.log('[VeiculoForm] pathname:', currentPath);

        if (routeId && routeId !== 'novo') {
            try {
                const response = await api.get(`/veiculo/${routeId}`);
                console.log('[VeiculoForm] response /veiculo/:id =>', response);

                const dados = (response.data && response.data.data && response.data.data[0]) ? response.data.data[0] : {};
                console.log('[VeiculoForm] dados extraídos =>', dados);

                if (!dados || Object.keys(dados).length === 0) {
                    console.warn('[VeiculoForm] Nenhum dado do veículo foi retornado para o routeId:', routeId);
                }

                if (dados && dados.kmatual === undefined) {
                    dados.kmatual = null;
                }

                // IMPORTANTE
                // seta o veículo imediatamente, antes das chamadas auxiliares.
                // Assim, mesmo se algum combo falhar, os campos principais aparecem.
                this.setState({
                    veiculo: {
                        ...dados,
                        flex: dados.flex || ANAO,
                        codtipoveiculo: dados.codtipoveiculo ? String(dados.codtipoveiculo) : '',
                        codcombustivel: dados.codcombustivel ? String(dados.codcombustivel) : '',
                        codcombustivel2: dados.codcombustivel2 ? String(dados.codcombustivel2) : '',
                        codmodeloveiculo: dados.codmodeloveiculo ? String(dados.codmodeloveiculo) : '',
                        codfornecedorveiculo: dados.codfornecedorveiculo ? String(dados.codfornecedorveiculo) : '',
                        codprojeto: dados.codprojeto ? String(dados.codprojeto) : '',
                        codfornecaquisicao: dados.codfornecaquisicao ? String(dados.codfornecaquisicao) : '',
                        codmotorista: dados.codmotorista ? String(dados.codmotorista) : ''
                    },
                    regimetrabalho: dados.regimetrabalho
                        ? String(dados.regimetrabalho)
                        : String(AREGIME_TRABALHO_NENHUM),
                    descritivo: dados.descritivo || '',
                    motivomanut: dados.motivomanut || '',
                    obsseguro: dados.obsseguro || '',
                    isNewRecord: false,
                    isView: (currentPath.includes('/view'))
                });

                // "let params" somente quando é preciso passar filtro específico de uma tabela
                let paramsmotorista = `?page=1&limit=500&funcionario=S`;
                let paramsfornecedorestransp = `?page=1&limit=500&transportadora=S`;

                const [
                    motoristasResp,
                    fornecedorestranspResp,
                    fornecedoresgeralResp,
                    tiposveiculoResp,
                    combustiveisResp,
                    modelosveiculoResp,
                    projetosResp,
                    fornecedorAquisicaoResp,
                    motoristaSelecionadoResp,
                    eixosResp
                ] = await Promise.all([
                    api.get(`/fornecedor/active/true${paramsmotorista}`),
                    api.get(`/fornecedor/active/true${paramsfornecedorestransp}`),
                    api.get(`/fornecedor/active/true`),
                    api.get(`/tipoveiculo/active/true`),
                    api.get(`/combustivel/active/true`),
                    api.get(`/modeloveiculo/active/true`),
                    api.get(`/financas/projeto/active/true`),
                    dados.codfornecaquisicao
                        ? api.get(`/fornecedor/listforchange/${dados.codfornecaquisicao}`)
                        : Promise.resolve({ data: [] }),
                    dados.codmotorista
                        ? api.get(`/fornecedor/listforchange/${dados.codmotorista}`)
                        : Promise.resolve({ data: [] }),
                    dados.codveiculo
                        ? api.get(`/veiculo/eixos/${dados.codveiculo}`)
                        : Promise.resolve({ data: [] })
                ]);

                console.log('[VeiculoForm] motoristasResp.data =>', motoristasResp.data);
                console.log('[VeiculoForm] fornecedorestranspResp.data =>', fornecedorestranspResp.data);
                console.log('[VeiculoForm] fornecedoresgeralResp.data =>', fornecedoresgeralResp.data);
                console.log('[VeiculoForm] tiposveiculoResp.data =>', tiposveiculoResp.data);
                console.log('[VeiculoForm] combustiveisResp.data =>', combustiveisResp.data);
                console.log('[VeiculoForm] modelosveiculoResp.data =>', modelosveiculoResp.data);
                console.log('[VeiculoForm] projetosResp.data =>', projetosResp.data);
                console.log('[VeiculoForm] fornecedorAquisicaoResp.data =>', fornecedorAquisicaoResp.data);
                console.log('[VeiculoForm] motoristaSelecionadoResp.data =>', motoristaSelecionadoResp.data);
                console.log('[VeiculoForm] eixosResp.data =>', eixosResp.data);

                const motoristas = Array.isArray(motoristasResp.data) ? [...motoristasResp.data] : [];
                const fornecedorestransp = Array.isArray(fornecedorestranspResp.data) ? [...fornecedorestranspResp.data] : [];
                const fornecedoresgeral = Array.isArray(fornecedoresgeralResp.data) ? [...fornecedoresgeralResp.data] : [];
                const tiposveiculo = Array.isArray(tiposveiculoResp.data?.data) ? [...tiposveiculoResp.data.data] : [];
                const combustiveis = Array.isArray(combustiveisResp.data) ? [...combustiveisResp.data] : [];
                const modelosveiculo = Array.isArray(modelosveiculoResp.data?.data) ? [...modelosveiculoResp.data.data] : [];
                const projetos = Array.isArray(projetosResp.data) ? [...projetosResp.data] : [];

                const fornecedorAquisicao = Array.isArray(fornecedorAquisicaoResp.data)
                    ? fornecedorAquisicaoResp.data
                    : (Array.isArray(fornecedorAquisicaoResp.data?.data) ? fornecedorAquisicaoResp.data.data : []);

                const motoristaSelecionado = Array.isArray(motoristaSelecionadoResp.data)
                    ? motoristaSelecionadoResp.data
                    : (Array.isArray(motoristaSelecionadoResp.data?.data) ? motoristaSelecionadoResp.data.data : []);

                fornecedorAquisicao.forEach(item => {
                    if (!fornecedoresgeral.some(f => String(f.codfornecedor) === String(item.codfornecedor))) {
                        fornecedoresgeral.push(item);
                    }
                });

                motoristaSelecionado.forEach(item => {
                    if (!motoristas.some(m => String(m.codfornecedor) === String(item.codfornecedor))) {
                        motoristas.push(item);
                    }
                });

                // garante selected item nos combos "listforchange", caso não esteja na lista ativa
                if (dados.codtipoveiculo && !tiposveiculo.some(t => String(t.codtipoveiculo) === String(dados.codtipoveiculo))) {
                    const tipoSelecionadoResp = await api.get(`/tipoveiculo/listforchange/${dados.codtipoveiculo}`);
                    const tipoSelecionado = Array.isArray(tipoSelecionadoResp.data)
                        ? tipoSelecionadoResp.data
                        : (Array.isArray(tipoSelecionadoResp.data?.data) ? tipoSelecionadoResp.data.data : []);
                    tipoSelecionado.forEach(item => {
                        if (!tiposveiculo.some(t => String(t.codtipoveiculo) === String(item.codtipoveiculo))) {
                            tiposveiculo.push(item);
                        }
                    });
                }

                if (dados.codcombustivel && !combustiveis.some(c => String(c.codcombustivel) === String(dados.codcombustivel))) {
                    const combustivelSelecionadoResp = await api.get(`/combustivel/listforchange/${dados.codcombustivel}`);
                    const combustivelSelecionado = Array.isArray(combustivelSelecionadoResp.data)
                        ? combustivelSelecionadoResp.data
                        : (Array.isArray(combustivelSelecionadoResp.data?.data) ? combustivelSelecionadoResp.data.data : []);
                    combustivelSelecionado.forEach(item => {
                        if (!combustiveis.some(c => String(c.codcombustivel) === String(item.codcombustivel))) {
                            combustiveis.push(item);
                        }
                    });
                }

                if (dados.codcombustivel2 && !combustiveis.some(c => String(c.codcombustivel) === String(dados.codcombustivel2))) {
                    const combustivel2SelecionadoResp = await api.get(`/combustivel/listforchange/${dados.codcombustivel2}`);
                    const combustivel2Selecionado = Array.isArray(combustivel2SelecionadoResp.data)
                        ? combustivel2SelecionadoResp.data
                        : (Array.isArray(combustivel2SelecionadoResp.data?.data) ? combustivel2SelecionadoResp.data.data : []);
                    combustivel2Selecionado.forEach(item => {
                        if (!combustiveis.some(c => String(c.codcombustivel) === String(item.codcombustivel))) {
                            combustiveis.push(item);
                        }
                    });
                }

                if (dados.codmodeloveiculo && !modelosveiculo.some(m => String(m.codmodeloveiculo) === String(dados.codmodeloveiculo))) {
                    const modeloSelecionadoResp = await api.get(`/modeloveiculo/listforchange/${dados.codmodeloveiculo}`);
                    const modeloSelecionado = Array.isArray(modeloSelecionadoResp.data)
                        ? modeloSelecionadoResp.data
                        : (Array.isArray(modeloSelecionadoResp.data?.data) ? modeloSelecionadoResp.data.data : []);
                    modeloSelecionado.forEach(item => {
                        if (!modelosveiculo.some(m => String(m.codmodeloveiculo) === String(item.codmodeloveiculo))) {
                            modelosveiculo.push(item);
                        }
                    });
                }

                if (dados.codprojeto && !projetos.some(p => String(p.codprojeto) === String(dados.codprojeto))) {
                    const projetoSelecionadoResp = await api.get(`/financas/projeto/listforchange/${dados.codprojeto}`);
                    const projetoSelecionado = Array.isArray(projetoSelecionadoResp.data)
                        ? projetoSelecionadoResp.data
                        : (Array.isArray(projetoSelecionadoResp.data?.data) ? projetoSelecionadoResp.data.data : []);
                    projetoSelecionado.forEach(item => {
                        if (!projetos.some(p => String(p.codprojeto) === String(item.codprojeto))) {
                            projetos.push(item);
                        }
                    });
                }

                this.setState({
                    motoristas,
                    fornecedorestransp,
                    fornecedoresgeral,
                    tiposveiculo,
                    combustiveis,
                    modelosveiculo,
                    projetos,
                    eixos: Array.isArray(eixosResp.data)
                        ? eixosResp.data.map(e => ({
                            ...e,
                            seqeixo: e.seqeixo !== null ? Number(e.seqeixo) : null
                        }))
                        : []
                }, () => {
                    console.log('[VeiculoForm] state.tiposveiculo =>', this.state.tiposveiculo);
                    console.log('[VeiculoForm] state.combustiveis =>', this.state.combustiveis);
                    console.log('[VeiculoForm] state.modelosveiculo =>', this.state.modelosveiculo);
                    console.log('[VeiculoForm] state.fornecedorestransp =>', this.state.fornecedorestransp);
                    console.log('[VeiculoForm] state.projetos =>', this.state.projetos);
                    console.log('[VeiculoForm] state.motoristas =>', this.state.motoristas);

                    this.logComboMatch('Combustível', this.state.combustiveis, 'codcombustivel', dados.codcombustivel);
                    this.logComboMatch('Combustível 2', this.state.combustiveis, 'codcombustivel', dados.codcombustivel2);
                    this.logComboMatch('Tipo de veículo', this.state.tiposveiculo, 'codtipoveiculo', dados.codtipoveiculo);
                    this.logComboMatch('Modelo', this.state.modelosveiculo, 'codmodeloveiculo', dados.codmodeloveiculo);
                    this.logComboMatch('Projeto', this.state.projetos, 'codprojeto', dados.codprojeto);
                    this.logComboMatch('Fornecedor do veículo', this.state.fornecedorestransp, 'codfornecedor', dados.codfornecedorveiculo);
                    this.logComboMatch('Fornecedor aquisição', this.state.fornecedoresgeral, 'codfornecedor', dados.codfornecaquisicao);
                    this.logComboMatch('Motorista padrão', this.state.motoristas, 'codfornecedor', dados.codmotorista);
                });

                if (dados?.codveiculo) {
                    this.listaDocumentos(dados.codveiculo);
                    this.listaOpcionais(dados.codveiculo);
                }

                const listaModelos = modelosveiculo; // preenche marca associada ao modelo

                if (dados?.codmodeloveiculo && listaModelos.length > 0) {
                    const modeloSelecionado = listaModelos.find(
                        (modelo) => modelo.codmodeloveiculo === Number(dados.codmodeloveiculo)
                    );

                    this.setState({
                        nomeMarcaAssociada: modeloSelecionado?.descmarcaveiculo || ''
                    });
                }
            } catch (error) {
                console.error('[VeiculoForm] Erro geral ao carregar tela:', error);
                if (error.response) {
                    console.error('[VeiculoForm] error.response.status:', error.response.status);
                    console.error('[VeiculoForm] error.response.data:', error.response.data);
                }
                this.handleOpenAlert('Erro ao carregar os dados do veículo!');
            }
        } else if (routeId === 'novo') {
            this.setState({
                isNewRecord: true,
                veiculo: {
                    ...veiculo,
                    descritivo: '',
                    motivomanut: '',
                    obsseguro: '',
                    regimetrabalho: 0
                }
            });

            // "let params" somente quando é preciso passar filtro específico de uma tabela
            let paramsmotorista = `?page=1&limit=500&funcionario=S`;
            let paramsfornecedorestransp = `?page=1&limit=500&transportadora=S`

            const motoristas = await api.get(`/fornecedor/active/true${paramsmotorista}`);
            this.setState({ motoristas: motoristas.data });

            const fornecedorestransp = await api.get(`/fornecedor/active/true${paramsfornecedorestransp}`);
            this.setState({ fornecedorestransp: fornecedorestransp.data });

            const fornecedoresgeral = await api.get(`/fornecedor/active/true`);
            this.setState({ fornecedoresgeral: fornecedoresgeral.data });

            const tiposveiculo = await api.get(`/tipoveiculo/active/true`);
            this.setState({ tiposveiculo: tiposveiculo.data?.data || [] });

            const combustiveis = await api.get(`/combustivel/active/true`);
            this.setState({ combustiveis: combustiveis.data });

            const modelosveiculo = await api.get(`/modeloveiculo/active/true`);
            this.setState({ modelosveiculo: modelosveiculo.data?.data || [] });

            const projetos = await api.get(`/financas/projeto/active/true`);
            this.setState({ projetos: projetos.data });
        }

        await this.carregaOpcionais();
    };

    /* Método carregar opcionais */
    carregaOpcionais = async () => {
        try {
            const response = await api.get('/opcionalveiculo', {
                params: { sort: 'DESCOPCIONALVEICULO' }
            });

            const opcionais = Array.isArray(response.data) ? response.data : (Array.isArray(response.data?.data) ? response.data.data : []);

            this.setState({
                opcionais: opcionais.map(opcional => ({
                    ...opcional,
                    inativoopc: opcional.inativoopc ?? opcional.inativo ?? ANAO
                })).sort((a, b) => String(a.descopcionalveiculo || '').localeCompare(
                    String(b.descopcionalveiculo || ''),
                    'pt-BR',
                    { sensitivity: 'base' }
                ))
            });
        } catch (error) {
            console.error('Erro ao carregar opcionais:', error);
            this.handleOpenAlert('Erro ao carregar opcionais!');
        }
    };

    /* Evento on change componentes */
    onChange = (event) => {
        const { errors } = this.state;
        const { name, type, value, checked } = event.target;

        if (errors[name]) {
            this.setState(prev => ({
                errors: {
                    ...prev.errors,
                    [name]: undefined
                }
            }));
        }

        // associa capacidadepax ao codtipoveiculo
        if (name === 'codtipoveiculo') {
            const { tiposveiculo } = this.state;

            const tipoSelecionado = tiposveiculo.find(
                (tipo) => String(tipo.codtipoveiculo) === String(value)
            );

            this.setState(prev => ({
                veiculo: {
                    ...prev.veiculo,
                    codtipoveiculo: value,
                    capacidadepax: tipoSelecionado && tipoSelecionado.capacidadepax !== undefined && tipoSelecionado.capacidadepax !== null ? tipoSelecionado.capacidadepax : ''
                }
            }));

            return;
        }

        // busca modelosveiculo do state
        if (name === 'codmodeloveiculo') {
            const { modelosveiculo } = this.state;

            const modeloSelecionado = modelosveiculo.find(
                (modelo) => modelo.codmodeloveiculo === Number(value)
            );

            this.setState({
                nomeMarcaAssociada: modeloSelecionado?.descmarcaveiculo || ''
            });
        }

        // não converter para Uppercase
        if (name === 'descritivo' || name === 'obsseguro' || name === 'motivomanut') {
            this.setState(prevState => ({
                veiculo: {
                    ...prevState.veiculo,
                    [name]: value
                }
            }));
            return;
        }

        // converte para Uppercase
        const camposUpper = [
            'nroveiculo',
            'descveiculo',
            'codrenavam',
            'placa',
            'chassi',
            'modelodechassi',
            'nrocarroceria'
        ]

        let adjustedValue;

        // ajuste de campos
        if (type === 'checkbox' && name === 'inativo') {
            adjustedValue = checked ? ANAO : ASIM;
        } else if (type === 'checkbox' && name === 'flex') {
            adjustedValue = checked ? ASIM : ANAO;
            this.setState(prevState => ({
                veiculo: {
                    ...prevState.veiculo,
                    flex: adjustedValue,
                    codcombustivel2: adjustedValue === ANAO ? '' : prevState.veiculo.codcombustivel2
                }
            }));
            return;
        } else if (type === 'checkbox' && name === 'veiculoproprio') {
            adjustedValue = checked ? ASIM : ANAO;
            this.setState(prevState => ({
                veiculo: {
                    ...prevState.veiculo,
                    veiculoproprio: adjustedValue,
                    abasteceveiculo: adjustedValue === ASIM ? '' : prevState.veiculo.abasteceveiculo
                }
            }));
            return;
        } else if (type === 'checkbox') {
            adjustedValue = checked ? ASIM : ANAO;
        } else if (type === 'radio') {
            adjustedValue = Number(value);
        } else if (camposUpper.includes(name)) {
            adjustedValue = value.toUpperCase();
        } else if (name === 'codcombustivel2') {
            adjustedValue = value ? Number(value) : '';
        } else {
            adjustedValue = value;
        }

        this.setState(prevState => ({
            veiculo: {
                ...prevState.veiculo,
                [name]: adjustedValue
            }
        }));
    };

    /* Evento on change componentes documentos */
    onChangeDocumento = (event) => {
        const { name, type, value, checked } = event.target;

        // não converter para Uppercase
        if (name === 'descritivodoc') {
            this.setState(prevState => ({
                documento: {
                    ...prevState.documento,
                    [name]: value
                }
            }));
            return;
        }

        // converter para campos Upper
        const camposUpper = ['descricao'];

        let adjustedValue;

        // ajuste de campos (código existente)
        if (type === 'checkbox' && name === 'inativodoc') {
            adjustedValue = checked ? ANAO : ASIM;
        } else if (type === 'checkbox') {
            adjustedValue = checked ? ASIM : ANAO;
        } else if (type === 'radio') {
            adjustedValue = Number(value);
        } else if (camposUpper.includes(name)) {
            adjustedValue = value.toUpperCase();
        } else {
            adjustedValue = value;
        }

        this.setState((prevState) => ({
            documento: {
                ...prevState.documento,
                [name]: adjustedValue
            }
        }));
    };

    /* Evento on change componentes opcionais */
    onChangeOpcional = (event) => {
        const { name, type, value, checked } = event.target;

        // converter para campos Upper
        const camposUpper = ['descopcionalveiculo'];

        let adjustedValue;

        // ajuste de campos (código existente)
        if (type === 'checkbox' && name === 'inativoopc') {
            adjustedValue = checked ? ANAO : ASIM;
        } else if (type === 'checkbox') {
            adjustedValue = checked ? ASIM : ANAO;
        } else if (type === 'radio') {
            adjustedValue = Number(value);
        } else if (camposUpper.includes(name)) {
            adjustedValue = value.toUpperCase();
        } else if (name === 'codopcionalveiculo') {
            adjustedValue = Number(value);
        } else {
            adjustedValue = value;
        }

        this.setState((prevState) => ({
            opcional: {
                ...prevState.opcional,
                [name]: adjustedValue
            }
        }));
    };

    /* Método para inserir novo eixo */
    handleAddEixo = () => {
        this.setState(prevState => {
            const novaLista = [...prevState.eixos];
            // pega o maior seqeixo existente (ignora nulls)
            const maiorSeq = novaLista.reduce((max, eixo) => {
                const valor = eixo.seqeixo !== null ? Number(eixo.seqeixo) : 0;
                return valor > max ? valor : max;
            }, 0);

            const proximoSeq = maiorSeq + 1;

            novaLista.push({
                seqeixo: proximoSeq,
                nrorodas: ''
            });

            return { eixos: novaLista };
        });
    };

    /* Método remover eixo localmente */
    handleRemoveEixo = () => {
        this.setState(prevState => {
            const novaLista = [...prevState.eixos];
            novaLista.pop();
            return { eixos: novaLista };
        });
    };

    /* Método alterar número de rodas */
    handleChangeRodas = (index, value) => {
        const num = parseInt(value);
        if (num >= 1 || value === '') {
            this.setState(prevState => {
                const novaLista = [...prevState.eixos];
                novaLista[index].nrorodas = value;
                return { eixos: novaLista };
            });
        }
    };

    /* Método seleção arquivo TS do veículo */
    handleFileTS = (event) => {
        const file = event.target.files[0];
        if (file) {
            this.setState(prevState => ({
                arquivoTS: file,
                veiculo: {
                    ...prevState.veiculo,
                    localdocsegts: file.name
                }
            }));
        }
    };

    /* Método remoção arquivo TS veículo*/
    handleDeleteFileTS = () => {
        this.setState(prevState => ({
            arquivoTS: null,
            veiculo: {
                ...prevState.veiculo,
                localdocsegts: ''
            }
        }), () => {
            if (this.inputFileTSRef.current) {
                this.inputFileTSRef.current.value = null;
            }
        });
    };

    /* Abre confirmação remoção arquivo TS veículo */
    handleOpenConfirmRemoveSeguroTS = () => {
        this.setState({ openConfirmRemoveSeguroTS: true });
    };

    /* Fecha confirmação remoção arquivo TS veículo */
    handleCloseConfirmRemoveSeguroTS = () => {
        this.setState({ openConfirmRemoveSeguroTS: false });
    };

    /* Método seleção arquivo TS do documento */
    handleFileDocumentoTS = (event) => {
        const file = event.target.files[0];
        if (file) {
            this.setState(prevState => ({
                arquivoDocTS: file,
                documento: {
                    ...prevState.documento,
                    localdocts: file.name
                }
            }));
        }
    };

    /* Método remoção arquivo TS do documento */
    handleDeleteFileDocumentoTS = () => {
        this.setState(prevState => ({
            arquivoDocTS: null,
            documento: {
                ...prevState.documento,
                localdocts: ''
            }
        }), () => {
            if (this.inputFileTSRef.current) {
                this.inputFileTSRef.current.value = null;
            }
        });
    };

    /* Abre confirmação remoção arquivo TS documento */
    handleOpenConfirmRemoveDocumentoTS = () => {
        this.setState({ openConfirmRemoveDocumentoTS: true });
    };

    /* Fecha confirmação remoção arquivo TS documento */
    handleCloseConfirmRemoveDocumentoTS = () => {
        this.setState({ openConfirmRemoveDocumentoTS: false });
    };

    /* Método seleção arquivo rede interna do veículo */
    handleFileRedeInterna = (event) => {
        const file = event.target.files[0];
        if (file) {
            this.setState(prevState => ({
                veiculo: {
                    ...prevState.veiculo,
                    localdocsegredeint: file.name
                },
                arquivoRedeInterna: file
            }));
        }
    };

    /* Método remoção arquivo rede interna veículo */
    handleDeleteFileRedeInterna = () => {
        this.setState(prevState => ({
            arquivoRedeInterna: null,
            veiculo: {
                ...prevState.veiculo,
                localdocsegredeint: ''
            }
        }), () => {
            if (this.inputFileRedeInternaRef.current) {
                this.inputFileRedeInternaRef.current.value = null;
            }
        });
    };

    /* Abre confirmação remoção arquivo rede interna veículo */
    handleOpenConfirmRemoveSeguroRedeInterna = () => {
        this.setState({ openConfirmRemoveSeguroRedeInterna: true });
    };

    /* Fecha confirmação remoção arquivo rede interna veículo */
    handleCloseConfirmRemoveSeguroRedeInterna = () => {
        this.setState({ openConfirmRemoveSeguroRedeInterna: false });
    };

    /* Método seleção arquivo rede interna do documento */
    handleFileDocumentoRedeInterna = (event) => {
        const file = event.target.files[0];
        if (file) {
            this.setState(prevState => ({
                documento: {
                    ...prevState.documento,
                    localdocredeint: file.name
                },
                arquivoDocRedeInterna: file
            }));
        }
    };

    /* Método remoção arquivo rede interna do documento */
    handleDeleteFileDocumentoRedeInterna = () => {
        this.setState(prevState => ({
            arquivoDocRedeInterna: null,
            documento: {
                ...prevState.documento,
                localdocredeint: ''
            }
        }), () => {
            if (this.inputFileRedeInternaRef.current) {
                this.inputFileRedeInternaRef.current.value = null;
            }
        });
    };

    /* Abre confirmação remoção arquivo rede interna documento */
    handleOpenConfirmRemoveDocumentoRedeInterna = () => {
        this.setState({ openConfirmRemoveDocumentoRedeInterna: true });
    };

    /* Fecha confirmação remoção arquivo rede interna documento */
    handleCloseConfirmRemoveDocumentoRedeInterna = () => {
        this.setState({ openConfirmRemoveDocumentoRedeInterna: false });
    };

    /* Atualiza dados de veículo existente - post */
    handleUpdateVeiculo = async () => {
        const { veiculo } = this.state;
        const { history } = this.props;

        try {
            const response = await api.put(`/veiculo/${veiculo.codveiculo}`, veiculo);
            if (response.status === 200) {
                history.push('/frotas/veiculo');
            }
        } catch (error) {
            this.handleOpenAlert(error.response.data.error);
        }
    };

    /* Abre janela de alerta com mensagem */
    handleOpenAlert = (message) => {
        this.setState({ openAlert: true });
        this.setState({ messageAlert: message });
    };

    /* Fecha janela mensagem alerta */
    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    };

    /* Troca aba superior */
    handleTabChange = (event, newValue) => {
        this.setState({ activeTab: newValue });
    };

    /* Reinicia state do documento */
    resetDocumentoState = () => ({
        documento: {
            chave: '',
            descricao: '',
            descritivodoc: '',
            vencimento: '',
            avisodiasantecedencia: '',
            localdocts: '',
            localdocredeint: '',
            inativodoc: ANAO
        },
        arquivoDocTS: null,
        arquivoDocRedeInterna: null,
        errors: {}
    });

    /* Sincroniza novo documento com novo veículo */
    sincronizaDocumentos = async (codveiculo) => {
        const { documentosveiculo } = this.state;

        if (!codveiculo) return;

        const listaDocumentos = Array.isArray(documentosveiculo) ? documentosveiculo : [];

        const documentosPendentes = listaDocumentos.filter(
            doc => !doc.chave || String(doc.chave).startsWith('tmp-doc-')
        );

        for (const doc of documentosPendentes) {
            const formData = new FormData();

            formData.append('descricao', doc.descricao || '');
            formData.append('descritivodoc', doc.descritivodoc || '');
            formData.append('vencimento', doc.vencimento || '');
            formData.append('avisodiasantecedencia', doc.avisodiasantecedencia || '');
            formData.append('localdocts', doc.localdocts || '');
            formData.append('localdocredeint', doc.localdocredeint || '');
            formData.append('inativodoc', doc.inativodoc || '');
            formData.append('codusuarioregistrou', Number(doc.codusuarioregistrou || 0));
            formData.append('codveiculo', codveiculo);

            await api.post('/docveiculo', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
        }

        await this.listaDocumentos(codveiculo);
    };

    /* Click salvar */
    onClickSave = async () => {
        const { veiculo, isNewRecord, eixos } = this.state;
        const { history, loadVeiculos } = this.props;
        let errors = this.validationRequiredFields();
        this.setState({ errors });

        if (Object.keys(errors).length > 0) {
            this.handleOpenAlert('Verifique os campos obrigatórios!');
            return;
        }

        // validação extra para ComboPadrao obrigatório
        const comboFields = [
            {
                field: 'codtipoveiculo',
                message: 'Selecione um tipo de veículo válido'
            },
            {
                field: 'codfornecedorveiculo',
                message: 'Selecione um fornecedor de veículo válido'
            }
        ];

        const comboErrors = {};

        comboFields.forEach(({ field, message }) => {
            if (isInvalidSelect(veiculo[field])) {
                comboErrors[field] = message;
            }
        });

        if (Object.keys(comboErrors).length > 0) {
            this.setState(prev => ({
                errors: {
                    ...prev.errors,
                    ...comboErrors
                }
            }));

            this.handleOpenAlert('Selecione registros válidos nos campos indicados em vermelho!');

            return;
        }

        try {
            const formData = new FormData();
            let codveiculoSalvo = veiculo.codveiculo;

            const codusuarioregistrou = sessionStorage.getItem('codUser') || localStorage.getItem('codUser');
            if (!codusuarioregistrou) {
                console.error('Erro: código do usuário não encontrado!');
                return;
            }

            // usa-se quando há campos do tipo BLOB
            formData.append('codtipoveiculo', veiculo.codtipoveiculo || '');
            formData.append('descveiculo', veiculo.descveiculo || '');
            formData.append('veiculoproprio', veiculo.veiculoproprio || '');
            formData.append('inativo', veiculo.inativo || '');
            formData.append('capacidadepax', veiculo.capacidadepax || '');
            formData.append('placa', veiculo.placa || '');
            formData.append('situacao', veiculo.situacao || '');
            formData.append('codfornecedorveiculo', veiculo.codfornecedorveiculo || '');
            formData.append('figuranomapa', veiculo.figuranomapa || '');
            formData.append('datahorainmanut', veiculo.datahorainmanut || '');
            formData.append('datahorafimmanut', veiculo.datahorafimmanut || '');
            formData.append('motivomanut', veiculo.motivomanut || '');
            formData.append('codusuariocolocoumanut', veiculo.codusuariocolocoumanut || '');
            formData.append('codrenavam', veiculo.codrenavam || '');
            formData.append('chassi', veiculo.chassi || '');
            formData.append('codcombustivel', veiculo.codcombustivel || '');
            formData.append('anofabricacao', veiculo.anofabricacao || '');
            formData.append('anomodelo', veiculo.anomodelo || '');
            formData.append('codmodeloveiculo', veiculo.codmodeloveiculo ? Number(veiculo.codmodeloveiculo) : '');
            formData.append('capacidadetanque', veiculo.capacidadetanque || '');
            formData.append('modelodechassi', veiculo.modelodechassi || '');
            formData.append('nrocarroceria', veiculo.nrocarroceria || '');
            formData.append('nroveiculo', veiculo.nroveiculo || '');
            formData.append('datacompraveiculo', veiculo.datacompraveiculo || '');
            formData.append('codfornecaquisicao', veiculo.codfornecaquisicao || '');
            formData.append('valoraquisicao', veiculo.valoraquisicao || '');
            formData.append('nronf', veiculo.nronf || '');
            formData.append('veiculousadoaquisicao', veiculo.veiculousadoaquisicao || '');
            formData.append('regimetrabalho', veiculo.regimetrabalho || '');
            formData.append('kmporlitro', veiculo.kmporlitro || '');
            formData.append('hodometroultimarevisao', veiculo.hodometroultimarevisao || '');
            formData.append('codmotorista', veiculo.codmotorista || '');
            formData.append('codprojeto', veiculo.codprojeto || '');
            formData.append('passapfranca', veiculo.passadpfranca || '');
            formData.append('passautoroutefranca', veiculo.passautoroutefranca || '');
            formData.append('descritivo', veiculo.descritivo || '');
            formData.append('codseguradora', veiculo.codseguradora || '');
            formData.append('iniciovigenciaseguro', veiculo.iniciovigenciaseguro || '');
            formData.append('fimvigenciaseguro', veiculo.fimvigenciaseguro || '');
            formData.append('apoliceseguro', veiculo.apoliceseguro || '');
            formData.append('franquiaseguro', veiculo.franquiaseguro || '');
            formData.append('danosmatseguro', veiculo.danosmatseguro || '');
            formData.append('danoscorpseguro', veiculo.danoscorpseguro || '');
            formData.append('danosmoraisseguro', veiculo.danosmoraisseguro || '');
            formData.append('obsseguro', veiculo.obsseguro || '');
            formData.append('localdocsegts', veiculo.localdocsegts || '');
            formData.append('localdocsegredeint', veiculo.localdocsegredeint || '');
            formData.append('avisovencsegurodias', veiculo.avisovencsegurodias || '');
            formData.append('flex', veiculo.flex || '');
            formData.append('codcombustivel2', veiculo.codcombustivel2 || '');
            formData.append('abasteceveiculo', veiculo.abasteceveiculo || '');
            formData.append('codusuarioregistrou', Number(codusuarioregistrou));
            formData.append('eixos', JSON.stringify(eixos));

            if (isNewRecord) {
                const response = await api.post('/veiculo', formData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                });

                codveiculoSalvo = response?.data?.codveiculo;

            } else {
                await api.put(`/veiculo/${veiculo.codveiculo}`, formData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                });

                codveiculoSalvo = veiculo.codveiculo;
            }

            if (loadVeiculos) loadVeiculos();

            await this.sincronizaDocumentos(codveiculoSalvo)
            await this.sincronizaOpcionais(codveiculoSalvo);
            history.push('/frotas/veiculo');

        } catch (error) {
            console.error('Erro ao salvar:', error.response?.data || error.message);
            this.handleOpenAlert(error.response?.data?.error || 'Erro ao salvar!');
        }
    };

    /* Sincroniza opcionais vinculados ao veículo com o banco */
    sincronizaOpcionais = async (codveiculo) => {
        const { opcionaisveiculo } = this.state;

        if (!codveiculo) {
            return;
        }

        try {
            // busca opcionais atuais no banco
            const response = await api.get(`/opcionaisdoveiculo/${codveiculo}`);
            const opcionaisBanco = response.data || [];

            const opcionaisBancoIds = opcionaisBanco.map(o => o.codopcionalveiculo);
            const opcionaisGridIds = opcionaisveiculo.map(o => o.codopcionalveiculo);

            // remove os que saíram da grid
            for (const opc of opcionaisBanco) {
                if (!opcionaisGridIds.includes(opc.codopcionalveiculo)) {
                    await api.delete(`/opcionaisdoveiculo/${opc.chave}`);
                }
            }

            // insere os que são novos na grid
            for (const id of opcionaisGridIds) {
                if (!opcionaisBancoIds.includes(id)) {
                    await api.post(`/opcionaisdoveiculo`, {
                        codveiculo,
                        codopcionalveiculo: id
                    });
                }
            }
        } catch (error) {
            console.error('Erro ao sincronizar opcionais do veículo:', error);
            this.handleOpenAlert('Erro ao salvar opcionais do veículo!');
        }
    };

    /* Click cancelar */
    onClickCancel = () => {
        this.props.history.push('/frotas/veiculo');
    };

    /* Valida campos obrigatórios ao salvar */
    validationRequiredFields() {
        const { schemaVeiculo, veiculo } = this.state;

        let errors = {};

        // valida campos do schema
        const requiredFields = [
            'nroveiculo',
            'codtipoveiculo',
            'codfornecedorveiculo'
        ];

        requiredFields.forEach(field => {
            const error = validateField(field, veiculo[field], schemaVeiculo);
            if (error) {
                errors[field] = error;
            }
        });

        return errors;
    };

    /* Valida campos obrigatórios ao salvar documento */
    validationRequiredFieldsDocumentos() {
        const { schemaDocumento, documento } = this.state;

        let errors = {};

        // valida campos do schema
        const requiredFields = ['descricao'];

        requiredFields.forEach(field => {
            const error = validateField(field, documento[field], schemaDocumento);
            if (error) {
                errors[field] = error;
            }
        });

        return errors;
    };

    /* Valida campos obrigatórios ao salvar opcional */
    validationRequiredFieldsOpcionais() {
        const { schemaOpcional, opcional } = this.state;

        let errors = {};

        // valida campos do schema
        const requiredFields = ['descopcionalveiculo'];

        requiredFields.forEach(field => {
            const error = validateField(field, opcional[field], schemaOpcional);
            if (error) {
                errors[field] = error;
            }
        });

        return errors;
    };

    /* Insere novo veículo */
    handleInsertVeiculo = async () => {
        const { veiculo } = this.state;
        const { history } = this.props;

        veiculo.codusuarioregistrou = parseInt(sessionStorage.getItem('codUser'));

        try {
            const response = await api.post(`/veiculo`, veiculo);
            if (response.status === 200) {
                history.push('/frotas/veiculo');
            }
        } catch (error) {
            this.handleOpenAlert(error.response.data.error);
        }
    };

    /* Insere opcional na grid */
    handleInsertOpcional = () => {
        const { opcional, opcionais, opcionaisveiculo } = this.state;
        const id = opcional.codopcionalveiculo;

        if (!id || id <= 0) {
            this.handleOpenAlert('Selecione um opcional para adicionar na grid!');
            return;
        }

        const jaExiste = opcionaisveiculo.some(item => item.codopcionalveiculo === id);
        if (jaExiste) {
            this.handleOpenAlert('O opcional selecionado já foi adicionado na grid!');
            return;
        }

        const opcionalSelecionado = opcionais.find(opc => opc.codopcionalveiculo === id);
        if (!opcionalSelecionado) {
            this.handleOpenAlert('Opcional não encontrado!');
            return;
        }

        this.setState(prevState => ({
            opcionaisveiculo: [...prevState.opcionaisveiculo, opcionalSelecionado],
            opcional: {
                codopcionalveiculo: 0,
                descopcionalveiculo: '',
                inativoopc: ANAO
            },
            openModalOpcionais: false
        }));
    };

    /* Inserção de documento */
    handleInsertDocumento = () => {
        const { documentosveiculo } = this.state;
        const novos = [...documentosveiculo];
        novos.push({ descricao: '', chave: '' });
        this.setState({ documentosveiculo: novos });
    };

    /* Click salvar documento */
    onClickSaveDocumento = async () => {
        const { documento, veiculo, arquivoDocTS, arquivoDocRedeInterna } = this.state;
        let errors = this.validationRequiredFieldsDocumentos();
        this.setState({ errors });

        if (Object.keys(errors).length > 0) {
            this.handleOpenAlert('Verifique os campos obrigatórios!');
            return;
        }

        try {
            const codusuarioregistrou = sessionStorage.getItem('codUser') || localStorage.getItem('codUser');
            if (!codusuarioregistrou) {
                this.handleOpenAlert('Usuário não identificado!');
                return;
            }

            if (!veiculo.codveiculo) {
                const chaveTemporaria = documento.chave && String(documento.chave).startsWith('tmp-doc-')
                    ? documento.chave
                    : `tmp-doc-${Date.now()}`;

                const documentoLocal = {
                    ...documento,
                    chave: chaveTemporaria,
                    codveiculo: '',
                    codusuarioregistrou: Number(codusuarioregistrou),
                    arquivoDocTS: arquivoDocTS || null,
                    arquivoDocRedeInterna: arquivoDocRedeInterna || null
                };

                this.setState(prevState => {
                    const jaExiste = prevState.documentosveiculo.some(
                        doc => String(doc.chave) === String(chaveTemporaria)
                    );

                    const documentosveiculo = jaExiste
                        ? prevState.documentosveiculo.map(doc =>
                            String(doc.chave) === String(chaveTemporaria) ? documentoLocal : doc
                        )
                        : [...prevState.documentosveiculo, documentoLocal];

                    return {
                        documentosveiculo,
                        openModalDocumentos: false,
                        ...this.resetDocumentoState()
                    };
                });

                return;
            }

            const formData = new FormData();

            formData.append('descricao', documento.descricao || '');
            formData.append('descritivodoc', documento.descritivodoc || '');
            formData.append('vencimento', documento.vencimento || '');
            formData.append('avisodiasantecedencia', documento.avisodiasantecedencia || '');
            formData.append('localdocts', documento.localdocts || '');
            formData.append('localdocredeint', documento.localdocredeint || '');
            formData.append('inativodoc', documento.inativodoc || '');
            formData.append('codusuarioregistrou', Number(codusuarioregistrou));
            formData.append('codveiculo', veiculo.codveiculo);

            for (let pair of formData.entries()) {
                console.log(pair[0] + ': ' + pair[1]);
            }

            let response;

            if (documento.chave) {
                response = await api.put(`/docveiculo/${documento.chave}`, formData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                });
            } else {
                response = await api.post('/docveiculo', formData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                });
            }

            if (response.status === 200) {
                await this.listaDocumentos();
                this.setState({
                    openModalDocumentos: false,
                    ...this.resetDocumentoState()
                });
            } else {
                this.handleOpenAlert('Erro ao salvar documento!');
            }
        } catch (error) {
            console.error('Erro ao salvar documento:', error);
            this.handleOpenAlert(
                error?.response?.data?.error ||
                error?.response?.data?.mensagem ||
                error?.message ||
                'Erro ao salvar documento!'
            );
        }
    };

    /* Abre modal para exclusão de documento */
    handleOpenDeleteDocumento = (chave) => {
        this.setState({ openConfirmDeleteDocumento: true, documentoASerExcluido: chave });
    };

    /* Fecha modal para exclusão de documento */
    handleCloseDeleteDocumento = () => {
        this.setState({ openConfirmDeleteDocumento: false, documentoASerExcluido: null });
    };

    /* Confirma exclusão documento */
    handleConfirmDeleteDocumento = async () => {
        const { documentoASerExcluido } = this.state;

        if (!documentoASerExcluido) {
            this.handleOpenAlert('Chave do documento inválida!');
        }

        if (String(documentoASerExcluido).startsWith('tmp-doc-')) {
            this.setState(prevState => ({
                documentosveiculo: prevState.documentosveiculo.filter(
                    doc => String(doc.chave) !== String(documentoASerExcluido)
                ),
                openConfirmDeleteDocumento: false,
                documentoASerExcluido: null
            }));

            return;
        }

        try {
            await api.delete(`/docveiculo/${documentoASerExcluido}`);
            await this.listaDocumentos();

            this.setState({
                openConfirmDeleteDocumento: false,
                documentoASerExcluido: null
            });
        } catch (error) {
            console.error('Erro ao excluir documento:', error);
            this.handleOpenAlert('Erro ao excluir o documento!');
            this.setState({ openConfirmDeleteDocumento: false });
        }
    };

    /* Alteração de documento */
    handleChangeDocumento = (doc) => {
        this.setState({
            documento: {
                ...doc
            },
            arquivoDocTS: doc.arquivoDocTS || null,
            arquivoDocRedeInterna: doc.arquivoDocRedeInterna || null,
            openModalDocumentos: true,
            isView: false
        });
    };

    /* Modal de documentos */
    handleOpenModalDocumentos = async () => {
        const { veiculo } = this.state;

        try {
            const response = await api.get('/docveiculo/active/true');

            this.setState({
                documentosDisponiveis: Array.isArray(response.data?.data) ? response.data.data : [],
                openModalDocumentos: true,
                documentoSelecionado: null,
                documento: {
                    chave: '',
                    descricao: '',
                    descritivodoc: '',
                    vencimento: '',
                    localdocts: '',
                    localdocredeint: '',
                    inativodoc: ANAO,
                    codusuarioregistrou: '',
                    datahoraregistro: '',
                    avisodiasantecedencia: '',
                    codveiculo: veiculo.codveiculo || ''
                },
                arquivoDocTS: null,
                arquivoDocRedeInterna: null
            });
        } catch (error) {
            console.error('Erro ao buscar documentos de veículo:', error);
        }
    };

    /* Click salvar opcional */
    onClickSaveOpcional = async () => {
        const { opcional } = this.state;
        let errors = {};
        this.setState({ errors });

        if (Object.keys(errors).length > 0) {
            this.handleOpenAlert('Verifique os campos obrigatórios!');
            return;
        }

        try {
            let response;

            const payload = {
                descopcionalveiculo: opcional.descopcionalveiculo,
                inativoopc: opcional.inativoopc || ANAO
            };

            if (opcional.codopcionalveiculo) {
                response = await api.put(`/opcionalveiculo/${opcional.codopcionalveiculo}`, payload);
            } else {
                response = await api.post(`/opcionalveiculo`, payload);
            }

            if (response.status === 200) {
                this.setState(prev => ({
                    opcionais: prev.opcionais.map(item => item.codopcionalveiculo === opcional.codopcionalveiculo ? {
                        ...item,
                        descopcionalveiculo: payload.descopcionalveiculo,
                        inativoopc: payload.inativoopc
                    } : item),
                    opcionaisveiculo: prev.opcionaisveiculo.map(item => item.codopcionalveiculo === opcional.codopcionalveiculo ? {
                        ...item,
                        descopcionalveiculo: payload.descopcionalveiculo,
                        inativoopc: payload.inativoopc
                    } : item),
                    openModalOne: false,
                    openModalTwo: false,
                }));

                await this.carregaOpcionais();
            } else {
                this.handleOpenAlert('Erro ao salvar opcional!');
            }
        } catch (error) {
            console.error('Erro ao salvar opcional:', error);
            this.handleOpenAlert('Erro ao salvar opcional!');
        }
    };

    /* Abre modal opcionais */
    handleOpenModalOpcionais = async () => {
        try {
            await this.carregaOpcionais();

            this.setState({
                openModalOpcionais: true,
                opcional: {
                    codopcionalveiculo: 0,
                    descopcionalveiculo: '',
                    inativoopc: ANAO
                }
            });
        } catch (error) {
            console.error('Erro ao buscar opcionais de veículo:', error);
            this.handleOpenAlert('Erro ao buscar opcionais de veículo!');
        }
    };

    /* Fecha modal de opcionais */
    handleCloseModalOpcionais = () => {
        this.setState({ openModalOpcionais: false });
    };

    /* Abre modal edição/visualização opcionais */
    handleOpenModalOne = (isView = false) => {
        const { opcional, opcionais } = this.state;
        const id = opcional.codopcionalveiculo;

        if (!id || id <= 0) {
            this.handleOpenAlert(
                isView ? 'Selecione um opcional para visualizar!' : 'Selecione um opcional para editar!'
            );

            return;
        }

        // busca o opcional completo na lista
        const opcionalSelecionado = opcionais.find(opc => opc.codopcionalveiculo === id);

        if (!opcionalSelecionado) {
            this.handleOpenAlert('Opcional não encontrado!');
            return;
        }

        this.setState({
            opcional: {
                codopcionalveiculo: opcionalSelecionado.codopcionalveiculo,
                descopcionalveiculo: opcionalSelecionado.descopcionalveiculo,
                inativoopc: opcionalSelecionado.inativoopc ?? opcionalSelecionado.inativo ?? ANAO
            },
            isView: isView,
            openModalOne: true
        });
    };

    /* Fecha modal edição/visualização opcionais */
    handleCloseModalOne = () => {
        this.setState({ openModalOne: false, isView: false });
    };

    /* Abre modal cadastro opcionais */
    handleOpenModalTwo = () => {
        this.setState({
            opcional: {
                codopcionalveiculo: 0,
                descopcionalveiculo: '',
                inativoopc: ANAO
            },
            openModalTwo: true,
            isView: false
        });
    };

    /* Fecha modal cadastro opcionais */
    handleCloseModalTwo = () => {
        this.setState({ openModalTwo: false });
    };

    /* Abre modal exclusão opcional */
    handleOpenDeleteOpcional = () => {
        const { opcional } = this.state;
        const id = opcional.codopcionalveiculo;

        if (!id || id <= 0) {
            this.handleOpenAlert('Selecione um opcional para excluir!');
            return;
        }

        this.setState({
            openConfirmDeleteOpcional: true,
            opcionalASerExcluido: id
        });
    };

    /* Modal remoção opcional grid */
    handleConfirmRemoveOpcional = () => {
        const { opcionalASerRemovido, opcionaisveiculo } = this.state;

        const novaLista = opcionaisveiculo.filter(
            opc => opc.codopcionalveiculo !== opcionalASerRemovido
        );

        this.setState({
            opcionaisveiculo: novaLista,
            openConfirmRemoveOpcional: false,
            opcionalASerRemovido: null
        });
    };

    /* Abre modal confirmação remoção opcional grid */
    handleOpenRemoveOpcional = (codopcionalveiculo) => {
        this.setState({
            openConfirmRemoveOpcional: true,
            opcionalASerRemovido: codopcionalveiculo
        });
    };

    /* Fecha modal confirmação remoção opcional grid */
    handleCloseRemoveOpcional = () => {
        this.setState({
            openConfirmRemoveOpcional: false,
            opcionalASerRemovido: null
        });
    };

    /* Fecha modal exclusão opcional */
    handleCloseDeleteOpcional = () => {
        this.setState({
            openConfirmDeleteOpcional: false,
            opcionalASerExcluido: null
        });
    };

    /* Confirma exclusão opcional do banco de dados */
    handleConfirmDeleteOpcional = async () => {
        const { opcionalASerExcluido } = this.state;

        try {
            const response = await api.delete(`/opcionalveiculo/${opcionalASerExcluido}`);

            if (response.status === 200) {
                this.setState({
                    opcional: {
                        codopcionalveiculo: 0,
                        descopcionalveiculo: '',
                        inativoopc: ANAO
                    },
                    openConfirmDeleteOpcional: false,
                    opcionalASerExcluido: null
                });
                this.carregaOpcionais();
            } else {
                this.handleOpenAlert('Erro ao excluir opcional!');
            }
        } catch (error) {
            console.error('Erro ao excluir opcional:', error);
            this.handleOpenAlert('Erro ao excluir opcional!');
        }
    };

    /* Método para tratar campos com vírgula */
    handleChangeValorMonetario = (e, campo) => {
        const raw = e.target.value;
        const semFormatacao = raw.replace(/[^\d,]/g, '');
        const numero = parseFloat(semFormatacao.replace(',', '.'));

        this.setState(prevState => ({
            veiculo: {
                ...prevState.veiculo,
                [campo]: !isNaN(numero) ? numero : ''
            }
        }));
    };

    /* Método para aceitar somente dígitos */
    handleNumericChange = (e) => {
        const { name, value } = e.target;
        const onlyDigits = value.replace(/\D/g, '');
        this.setState(prev => ({
            veiculo: { ...prev.veiculo, [name]: onlyDigits }
        }));
    };

    /* Componente auxiliar TabContainer */
    TabContainer = ({ children, value, index }) => {
        return (
            <div
                role="tabpanel"
                hidden={value !== index}
            >
                {value === index && <Box mt={2}>{children}</Box>}
            </div>
        );
    };

    render() {
        const {
            veiculo,
            documento,
            opcional,
            tiposveiculo,
            combustiveis,
            modelosveiculo,
            projetos,
            motoristas,
            fornecedorestransp,
            fornecedoresgeral,
            errors,
            isView,
            activeTab,
            nomeMarcaAssociada,
            eixos,
            documentosveiculo,
            opcionaisveiculo,
            openModalDocumentos,
            openAlert,
            opcionais,
            messageAlert,
            documentoASerExcluido,
            openConfirmDeleteDocumento,
            openModalOpcionais,
            openModalOne,
            openModalTwo,
            openConfirmDeleteOpcional,
            opcionalASerExcluido,
            opcionalASerRemovido,
            openConfirmRemoveOpcional,
            arquivoDocTS,
            arquivoDocRedeInterna,
            arquivoTS,
            arquivoRedeInterna,
            openConfirmRemoveSeguroTS,
            openConfirmRemoveSeguroRedeInterna,
            openConfirmRemoveDocumentoTS,
            openConfirmRemoveDocumentoRedeInterna
        } = this.state;
        const isUploadDisabledTS = !!(arquivoDocTS || documento.localdocts);
        const isDeleteDisabledTS = !(arquivoDocTS || documento.localdocts);
        const isUploadDisabledRedeInterna = !!(arquivoDocRedeInterna || documento.localdocredeint);
        const isDeleteDisabledRedeInterna = !(arquivoDocRedeInterna || documento.localdocredeint);
        const isUploadDisabledSegTS = !!(arquivoTS || veiculo.localdocsegts);
        const isDeleteDisabledSegTS = !(arquivoTS || veiculo.localdocsegts);
        const isUploadDisabledSegRedeInterna = !!(arquivoRedeInterna || veiculo.localdocsegredeint);
        const isDeleteDisabledSegRedeInterna = !(arquivoRedeInterna || veiculo.localdocsegredeint);

        return (
            <div>
                <AppBar
                    position="static"
                    color="default"
                >
                    <Tabs
                        value={activeTab}
                        onChange={this.handleTabChange}
                        indicatorColor="primary"
                        textColor="primary"
                        variant="fullWidth"
                    >
                        <Tab label="Identificação" />

                        <Tab label="Eixos" />

                        <Tab label="Geral" />

                        <Tab label="Opcionais" />

                        <Tab label="Seguro" />

                        <Tab label="Documentos" />
                    </Tabs>
                </AppBar>

                {activeTab === 0 &&
                    <TabContainer>
                        <CardContent>
                            <Box
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                            >
                                <Typography
                                    component="h1"
                                    variant="h3"
                                >
                                    Veículo {veiculo.codveiculo}
                                </Typography>

                                <FormControlLabel
                                    label={veiculo.inativo === ANAO ? 'Ativo' : 'Inativo'}
                                    control={
                                        <Switch
                                            checked={veiculo.inativo === ANAO}
                                            name="inativo"
                                            onChange={this.onChange}
                                            color="primary"
                                            disabled={isView}
                                        />
                                    }
                                />
                            </Box>

                            <br />

                            <Box
                                display="flex"
                                justifyContent="space-between"
                                alignItems="flex-start"
                                style={{ marginBottom: '1rem' }}
                            >
                                <Box
                                    display="flex"
                                    flex="1"
                                >
                                    <TextField
                                        label="Veículo"
                                        name="nroveiculo"
                                        value={veiculo.nroveiculo || ''}
                                        variant="outlined"
                                        onChange={this.onChange}
                                        helperText={errors.nroveiculo || ''}
                                        error={!!errors.nroveiculo}
                                        disabled={isView}
                                        inputProps={{ maxLength: 50 }}
                                        style={{
                                            marginRight: '1rem',
                                            width: '25%'
                                        }}
                                    />

                                    <TextField
                                        label="Descrição"
                                        name="descveiculo"
                                        value={veiculo.descveiculo || ''}
                                        variant="outlined"
                                        onChange={this.onChange}
                                        disabled={isView}
                                        inputProps={{ maxLength: 50 }}
                                        style={{
                                            width: '40%',
                                            marginRight: '1.5rem'
                                        }}
                                    />

                                    <FormControlLabel
                                        label={'Flex'}
                                        control={
                                            <Checkbox
                                                checked={(veiculo.flex === ASIM)}
                                                name="flex"
                                                onChange={this.onChange}
                                                color="primary"
                                                disabled={isView}
                                            />
                                        }
                                    />
                                </Box>

                                <div style={{ marginRight: 30, textAlign: 'center' }}>
                                    <Typography
                                        variant="subtitle2"
                                        style={{ marginBottom: 5 }}
                                    >
                                        Hodômetro
                                    </Typography>

                                    <Typography
                                        variant="h5"
                                        style={{ fontWeight: 'bold' }}
                                    >
                                        {veiculo.kmatual !== null && veiculo.kmatual !== undefined ? veiculo.kmatual.toLocaleString() : '0'}
                                    </Typography>
                                </div>
                            </Box>

                            <Box style={{ marginTop: '17px', display: 'flex', gap: '1rem' }}>
                                <FormControl style={{ width: '22%' }}>
                                    <ComboPadrao
                                        name={'codcombustivel'}
                                        label={'Combustível'}
                                        value={veiculo.codcombustivel}
                                        onChange={this.onChange}
                                        fieldId={'codcombustivel'}
                                        listItems={combustiveis}
                                        fieldDescription={'desccombustivel'}
                                    />
                                </FormControl>

                                {veiculo.flex === ASIM && (
                                    <FormControl
                                        style={{ width: '22%' }}
                                        variant="outlined"
                                        disabled={isView}
                                    >
                                        <ComboPadrao
                                            name={'codcombustivel2'}
                                            label={'Combustível 2'}
                                            value={veiculo.codcombustivel2}
                                            onChange={this.onChange}
                                            fieldId={'codcombustivel'}
                                            listItems={combustiveis}
                                            fieldDescription={'desccombustivel'}
                                        />
                                    </FormControl>
                                )}

                                <TextField
                                    label="Consumo (KM/Litro)"
                                    name="kmporlitro"
                                    value={veiculo.kmporlitro !== '' && veiculo.kmporlitro !== null && veiculo.kmporlitro !== undefined ? formatCurrency(veiculo.kmporlitro) : '0,00'}
                                    variant="outlined"
                                    onChange={(e) => this.handleChangeValorMonetario(e, 'kmporlitro')}
                                    disabled={isView}
                                    type="text"
                                    style={{ width: veiculo.flex === ASIM ? '25%' : '25%' }}
                                />

                                <TextField
                                    label="Capacidade do tanque"
                                    name="capacidadetanque"
                                    value={veiculo.capacidadetanque !== '' && veiculo.capacidadetanque !== null && veiculo.capacidadetanque !== undefined ? formatCurrency(veiculo.capacidadetanque) : '0,00'}
                                    variant="outlined"
                                    onChange={(e) => this.handleChangeValorMonetario(e, 'capacidadetanque')}
                                    disabled={isView}
                                    type="text"
                                    style={{ width: '230px' }}
                                />
                            </Box>

                            <Box style={{ marginTop: '17px' }}>
                                <TextField
                                    label="Código RENAVAM"
                                    name="codrenavam"
                                    value={veiculo.codrenavam || ''}
                                    variant="outlined"
                                    onChange={this.handleNumericChange}
                                    disabled={isView}
                                    inputProps={{ inputMode: 'numeric', pattern: '[0-9]*', maxLength: 50 }}
                                    style={{
                                        marginRight: '1rem',
                                        width: '25%'
                                    }}
                                />

                                <TextField
                                    label="Placa"
                                    name="placa"
                                    value={veiculo.placa || ''}
                                    variant="outlined"
                                    onChange={this.onChange}
                                    disabled={isView}
                                    inputProps={{ maxLength: 50 }}
                                    style={{
                                        marginRight: '1rem',
                                        width: '20%'
                                    }}
                                />

                                <FormControl style={{ width: '30%' }}>
                                    <ComboPadrao
                                        name={'codtipoveiculo'}
                                        label={'Tipo de veículo'}
                                        value={veiculo.codtipoveiculo}
                                        onChange={this.onChange}
                                        fieldId={'codtipoveiculo'}
                                        listItems={tiposveiculo}
                                        fieldDescription={'desctipoveiculo'}
                                        error={!!errors.codtipoveiculo}
                                        helperText={errors.codtipoveiculo || ''}
                                    />
                                </FormControl>
                            </Box>

                            <Box
                                display="flex"
                                gap="1rem"
                                alignItems="center"
                                style={{ marginTop: '17px' }}
                            >
                                <FormControl style={{ width: '47%', marginRight: '1.5rem' }}>
                                    <ComboPadrao
                                        name={'codmodeloveiculo'}
                                        label={'Modelo'}
                                        value={veiculo.codmodeloveiculo}
                                        onChange={this.onChange}
                                        fieldId={'codmodeloveiculo'}
                                        listItems={modelosveiculo}
                                        fieldDescription={'descmodeloveiculo'}
                                    />
                                </FormControl>

                                {nomeMarcaAssociada && (
                                    <Box style={{ width: '35%' }}>
                                        <Typography
                                            variant="body1"
                                            style={{ fontWeight: 'bold' }}
                                        >
                                            {nomeMarcaAssociada}
                                        </Typography>
                                    </Box>
                                )}
                            </Box>

                            <Box style={{ marginTop: '17px' }}>
                                <FormControl style={{ width: '40%', marginRight: '1rem' }}>
                                    <ComboPadrao
                                        name={'codfornecedorveiculo'}
                                        label={'Fornecedor do veículo'}
                                        value={veiculo.codfornecedorveiculo}
                                        onChange={this.onChange}
                                        fieldId={'codfornecedor'}
                                        listItems={fornecedorestransp}
                                        fieldDescription={'fantasia'}
                                        error={!!errors.codfornecedorveiculo}
                                        helperText={errors.codfornecedorveiculo || ''}
                                    />
                                </FormControl>

                                <FormControl style={{ width: '30%' }}>
                                    <ComboPadrao
                                        name={'codprojeto'}
                                        label={'Projeto'}
                                        value={veiculo.codprojeto}
                                        onChange={this.onChange}
                                        fieldId={'codprojeto'}
                                        listItems={projetos}
                                        fieldDescription={'descprojeto'}
                                    />
                                </FormControl>
                            </Box>

                            <Box style={{ marginTop: '17px' }}>
                                <TextField
                                    label="Chassi"
                                    name="chassi"
                                    value={veiculo.chassi || ''}
                                    variant="outlined"
                                    onChange={this.onChange}
                                    disabled={isView}
                                    inputProps={{ maxLength: 50 }}
                                    style={{
                                        width: '25%',
                                        marginRight: '1rem'
                                    }}
                                />

                                <TextField
                                    label="Modelo de chassi"
                                    name="modelodechassi"
                                    value={veiculo.modelodechassi || ''}
                                    variant="outlined"
                                    onChange={this.onChange}
                                    disabled={isView}
                                    inputProps={{ maxLength: 50 }}
                                    style={{
                                        width: '25%',
                                        marginRight: '1rem'
                                    }}
                                />

                                <TextField
                                    label="Número carroceria"
                                    style={{ width: '25%' }}
                                    name="nrocarroceria"
                                    value={veiculo.nrocarroceria || ''}
                                    variant="outlined"
                                    onChange={this.onChange}
                                    disabled={isView}
                                    inputProps={{ maxLength: 50 }}
                                />
                            </Box>

                            <Box style={{ marginTop: '17px' }}>
                                <TextField
                                    label="Ano fabricação"
                                    name="anofabricacao"
                                    value={veiculo.anofabricacao || ''}
                                    variant="outlined"
                                    disabled={isView}
                                    type="number"
                                    inputProps={{ min: 1 }}
                                    onChange={(e) => {
                                        const valor = parseInt(e.target.value);
                                        if (valor >= 1 || e.target.value === '') {
                                            this.onChange(e);
                                        }
                                    }}
                                    style={{
                                        marginRight: "1rem",
                                        width: '20%'
                                    }}
                                />

                                <TextField
                                    label="Ano modelo"
                                    name="anomodelo"
                                    value={veiculo.anomodelo || ''}
                                    variant="outlined"
                                    disabled={isView}
                                    type="number"
                                    style={{ width: '20%' }}
                                    inputProps={{ min: 1 }}
                                    onChange={(e) => {
                                        const valor = parseInt(e.target.value);
                                        if (valor >= 1 || e.target.value === '') {
                                            this.onChange(e);
                                        }
                                    }}
                                />
                            </Box>

                            <br />
                            <br />
                            <br />

                            <Box
                                style={{
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    gap: 10
                                }}
                            >
                                <Button
                                    name="salvar"
                                    color="primary"
                                    variant="contained"
                                    onClick={this.onClickSave}
                                    disabled={isView}
                                >
                                    Salvar
                                </Button>

                                <Button
                                    name="cancelar"
                                    variant="contained"
                                    onClick={this.onClickCancel}
                                    color="secondary"
                                >
                                    Cancelar
                                </Button>
                            </Box>
                        </CardContent>
                    </TabContainer>
                }

                {activeTab === 1 &&
                    <TabContainer>
                        <CardContent>
                            <Box
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                            >
                                <Typography
                                    component="h1"
                                    variant="h3"
                                    style={{ marginBottom: '1rem' }}
                                >
                                    Veículo {veiculo.codveiculo}
                                </Typography>
                            </Box>

                            <CardContent>
                                <Box
                                    style={{
                                        height: 300,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center'
                                    }}
                                >
                                    <TableContainer
                                        component={Paper}
                                        style={{
                                            maxHeight: 400,
                                            overflowY: 'auto',
                                            width: 800
                                        }}
                                    >
                                        <Table
                                            size="small"
                                            style={{ tableLayout: 'fixed' }}
                                        >
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell
                                                        align="center"
                                                        style={{ width: '33%' }}
                                                    >
                                                        <strong>Eixo</strong>
                                                    </TableCell>

                                                    <TableCell
                                                        align="center"
                                                        style={{ width: '33%' }}
                                                    >
                                                        <strong>Nº Rodas</strong>
                                                    </TableCell>

                                                    <TableCell
                                                        align="right"
                                                        style={{ width: '34%', minWidth: 160 }}
                                                    >
                                                        <Box
                                                            display="flex"
                                                            justifyContent="flex-end"
                                                            gap={1}
                                                        >
                                                            <Button
                                                                variant="outlined"
                                                                color="secondary"
                                                                onClick={this.handleRemoveEixo}
                                                                disabled={isView || eixos.length === 0}
                                                                style={{ marginRight: 8 }}
                                                            >
                                                                Excluir
                                                            </Button>

                                                            <Button
                                                                variant="contained"
                                                                color="primary"
                                                                onClick={this.handleAddEixo}
                                                                disabled={isView}
                                                            >
                                                                Inserir
                                                            </Button>
                                                        </Box>
                                                    </TableCell>
                                                </TableRow>
                                            </TableHead>

                                            <TableBody>
                                                {eixos.map((eixo, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell
                                                            align="center"
                                                            style={{ verticalAlign: 'middle' }}
                                                        >
                                                            {eixo.seqeixo}
                                                        </TableCell>

                                                        <TableCell
                                                            align="center"
                                                            style={{ verticalAlign: 'middle' }}
                                                        >
                                                            <TextField
                                                                value={eixo.nrorodas}
                                                                type="number"
                                                                onChange={(e) => this.handleChangeRodas(index, e.target.value)}
                                                                variant="outlined"
                                                                size="small"
                                                                style={{ width: 80 }}
                                                                inputProps={{ min: 1, style: { textAlign: 'center' } }}
                                                                disabled={isView}
                                                            />
                                                        </TableCell>

                                                        <TableCell />
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Box>
                            </CardContent>

                            <br />
                            <br />
                            <br />

                            <Box
                                style={{
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    gap: 10
                                }}
                            >
                                <Button
                                    name="salvar"
                                    color="primary"
                                    variant="contained"
                                    onClick={this.onClickSave}
                                    disabled={isView}
                                >
                                    Salvar
                                </Button>

                                <Button
                                    name="cancelar"
                                    variant="contained"
                                    onClick={this.onClickCancel}
                                    color="secondary"
                                >
                                    Cancelar
                                </Button>
                            </Box>
                        </CardContent>
                    </TabContainer>
                }

                {activeTab === 2 &&
                    <TabContainer>
                        <CardContent>
                            <Box
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                            >
                                <Typography
                                    component="h1"
                                    variant="h3"
                                >
                                    Veículo {veiculo.codveiculo}
                                </Typography>
                            </Box>

                            <br />

                            <Box
                                display="flex"
                                alignItems="center"
                                style={{ marginTop: '15px' }}
                            >
                                <TextField
                                    label="Capacidade de pax"
                                    name="capacidadepax"
                                    value={veiculo.capacidadepax || ''}
                                    variant="outlined"
                                    disabled={isView}
                                    type="number"
                                    inputProps={{ min: 1 }}
                                    onChange={(e) => {
                                        const valor = parseInt(e.target.value);
                                        if (valor >= 1 || e.target.value === '') {
                                            this.onChange(e);
                                        }
                                    }}
                                    style={{
                                        width: '243px',
                                        marginRight: '1rem'
                                    }}
                                />

                                <TextField
                                    label="Hodômetro última revisão"
                                    name="hodometroultimarevisao"
                                    value={veiculo.hodometroultimarevisao || ''}
                                    variant="outlined"
                                    disabled={isView}
                                    type="number"
                                    inputProps={{ min: 1 }}
                                    onChange={(e) => {
                                        const valor = parseInt(e.target.value);
                                        if (valor >= 1 || e.target.value === '') {
                                            this.onChange(e);
                                        }
                                    }}
                                    style={{
                                        width: '243px',
                                        marginRight: '2rem'
                                    }}
                                />

                                <FormControlLabel
                                    label={'Veículo próprio'}
                                    style={{ marginRight: '1rem' }}
                                    control={
                                        <Checkbox
                                            checked={(veiculo.veiculoproprio === ASIM)}
                                            name="veiculoproprio"
                                            onChange={this.onChange}
                                            color="primary"
                                            disabled={isView}
                                        />
                                    }
                                />

                                <FormControlLabel
                                    label={'Figura no mapa de veículos'}
                                    control={
                                        <Checkbox
                                            checked={(veiculo.figuranomapa === ASIM)}
                                            name="figuranomapa"
                                            onChange={this.onChange}
                                            color="primary"
                                            disabled={isView}
                                        />
                                    }

                                />

                                {veiculo.veiculoproprio !== ASIM && (
                                    <FormControlLabel
                                        label={'Abastece veículo'}
                                        style={{ marginRight: '1rem' }}
                                        control={
                                            <Checkbox
                                                checked={(veiculo.abasteceveiculo === ASIM)}
                                                name="abasteceveiculo"
                                                onChange={this.onChange}
                                                color="primary"
                                                disabled={isView}
                                            />
                                        }
                                    />
                                )}
                            </Box>

                            <fieldset
                                style={{
                                    width: '96%',
                                    marginTop: '25px',
                                    padding: '22px',
                                    borderRadius: '5px',
                                    border: '1px solid #ccc'
                                }}
                            >
                                <legend
                                    style={{
                                        padding: '0 10px',
                                        fontFamily: 'Calibri, sans-serif',
                                        fontWeight: 'bold',
                                        color: '#808080'
                                    }}
                                >
                                    Dados aquisição
                                </legend>

                                <Box style={{ width: '100%' }}>
                                    <TextField
                                        label="Data"
                                        name="datacompraveiculo"
                                        onChange={this.onChange}
                                        type="date"
                                        value={veiculo.datacompraveiculo ? veiculo.datacompraveiculo.substring(0, 10) : ''}
                                        variant="outlined"
                                        disabled={isView}
                                        InputLabelProps={{
                                            shrink: true,
                                            required: false
                                        }}
                                        style={{
                                            width: '20%',
                                            marginRight: '2rem'
                                        }}
                                    />

                                    <TextField
                                        label="Valor"
                                        name="valoraquisicao"
                                        value={veiculo.valoraquisicao !== '' && veiculo.valoraquisicao !== null && veiculo.valoraquisicao !== undefined ? formatCurrency(veiculo.valoraquisicao) : '0,00'}
                                        variant="outlined"
                                        onChange={(e) => this.handleChangeValorMonetario(e, 'valoraquisicao')}
                                        disabled={isView}
                                        type="text"
                                        style={{
                                            width: '25%',
                                            marginRight: '1rem'
                                        }}
                                    />

                                    <TextField
                                        label="Número NF"
                                        name="nronf"
                                        value={veiculo.nronf || ''}
                                        variant="outlined"
                                        disabled={isView}
                                        type="number"
                                        style={{ width: '25%' }}
                                        inputProps={{ min: 1 }}
                                        onChange={(e) => {
                                            const valor = parseInt(e.target.value);
                                            if (valor >= 1 || e.target.value === '') {
                                                this.onChange(e);
                                            }
                                        }}
                                    />
                                </Box>

                                <Box
                                    display="flex"
                                    alignItems="center"
                                    style={{
                                        width: '100%',
                                        marginTop: '17px'
                                    }}
                                >
                                    <FormControl style={{ marginRight: '2rem', width: '59%' }}>
                                        <ComboPadrao
                                            name={'codfornecaquisicao'}
                                            label={'Fornecedor aquisição'}
                                            value={veiculo.codfornecaquisicao}
                                            onChange={this.onChange}
                                            fieldId={'codfornecedor'}
                                            listItems={fornecedoresgeral}
                                            fieldDescription={'fantasia'}
                                        />
                                    </FormControl>

                                    <FormControlLabel
                                        label={'Veículo usado'}
                                        control={
                                            <Checkbox
                                                checked={(veiculo.veiculousadoaquisicao === ASIM)}
                                                name="veiculousadoaquisicao"
                                                onChange={this.onChange}
                                                color="primary"
                                                disabled={isView}
                                            />
                                        }
                                    />
                                </Box>
                            </fieldset>

                            <Box style={{ marginTop: '25px' }}>
                                <FormControl
                                    variant="filled"
                                    disabled={isView}
                                    style={{
                                        marginRight: "1rem",
                                        width: "40%"
                                    }}
                                >
                                    <InputLabel
                                        htmlFor="outlined-age-native-simple"
                                        shrink={true}
                                        style={{ padding: '0 4px' }}
                                    >
                                        Regime de trabalho
                                    </InputLabel>

                                    <Select
                                        label="Regime de trabalho"
                                        native
                                        onChange={this.onChange}
                                        value={String(veiculo.regimetrabalho ?? AREGIME_TRABALHO_NENHUM)}
                                        inputProps={{
                                            id: 'outlined-age-native-simple',
                                            name: 'regimetrabalho'
                                        }}
                                    >
                                        <option
                                            key={AREGIME_TRABALHO_NENHUM}
                                            value={AREGIME_TRABALHO_NENHUM}
                                        >
                                            {"Nenhum"}
                                        </option>

                                        <option
                                            key={AREGIME_TRABALHO_SEVERO}
                                            value={AREGIME_TRABALHO_SEVERO}
                                        >
                                            {"Severo"}
                                        </option>

                                        <option
                                            key={AREGIME_TRABALHO_MISTO}
                                            value={AREGIME_TRABALHO_MISTO}
                                        >
                                            {"Misto"}
                                        </option>

                                        <option
                                            key={AREGIME_TRABALHO_RODOVIARIO}
                                            value={AREGIME_TRABALHO_RODOVIARIO}
                                        >
                                            {"Rodoviário"}
                                        </option>
                                    </Select>
                                </FormControl>

                                <FormControl
                                    style={{ width: '588px' }}
                                    variant="outlined"
                                    disabled={isView}
                                >
                                    <ComboPadrao
                                        name={'codmotorista'}
                                        label={'Motorista padrão'}
                                        value={veiculo.codmotorista}
                                        onChange={this.onChange}
                                        fieldId={'codfornecedor'}
                                        listItems={motoristas}
                                        fieldDescription={'fantasia'}
                                    />
                                </FormControl>
                            </Box>

                            <Box style={{ marginTop: '17px' }}>
                                <Typography
                                    color="textSecondary"
                                    component="p"
                                    variant="body2"
                                >
                                    Descritivo
                                </Typography>

                                <FormGroup>
                                    <textarea
                                        id="descritivo"
                                        name="descritivo"
                                        onChange={this.onChange}
                                        value={veiculo.descritivo}
                                        disabled={isView}
                                        style={{
                                            width: '96%',
                                            height: '80px',
                                            padding: '8px',
                                            border: '1px solid #ccc',
                                            borderRadius: '4px',
                                            fontFamily: 'Calibri, sans-serif'
                                        }}
                                    />
                                </FormGroup>
                            </Box>

                            <br />
                            <br />
                            <br />

                            <Box
                                style={{
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    gap: 10
                                }}
                            >
                                <Button
                                    name="salvar"
                                    color="primary"
                                    variant="contained"
                                    onClick={this.onClickSave}
                                    disabled={isView}
                                >
                                    Salvar
                                </Button>

                                <Button
                                    name="cancelar"
                                    variant="contained"
                                    onClick={this.onClickCancel}
                                    color="secondary"
                                >
                                    Cancelar
                                </Button>
                            </Box>
                        </CardContent>
                    </TabContainer>
                }

                {activeTab === 3 &&
                    <TabContainer>
                        <CardContent>
                            <Box
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                            >
                                <Typography
                                    component="h1"
                                    variant="h3"
                                >
                                    Veículo {veiculo.codveiculo}
                                </Typography>
                            </Box>

                            <br />

                            <FormLabel
                                component="legend"
                                disabled={isView}
                                style={{
                                    textAlign: 'center',
                                    backgroundColor: '#e0e0e0',
                                    padding: '3px'
                                }}
                            >
                                Opcionais de veículo
                            </FormLabel>

                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="center">Código</TableCell>

                                        <TableCell align="center">Descrição</TableCell>

                                        <TableCell align="center">Inativo</TableCell>

                                        <TableCell align="center">Ações</TableCell>

                                        <TableCell align="center">
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    justifyContent: 'flex-end',
                                                    alignItems: 'center'
                                                }}
                                            >
                                                <Button
                                                    variant="outlined"
                                                    color="primary"
                                                    disabled={isView}
                                                    onClick={this.handleOpenModalOpcionais}
                                                    style={{
                                                        backgroundColor: colors.grey[300],
                                                        color: 'black',
                                                        padding: '4px 12px'
                                                    }}
                                                >
                                                    Inserir
                                                </Button>
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {opcionaisveiculo.map((opc, index) => (
                                        <TableRow key={index}>
                                            <TableCell align="center">{opc.codopcionalveiculo}</TableCell>

                                            <TableCell align="center">{opc.descopcionalveiculo}</TableCell>

                                            <TableCell align="center">{opc.inativoopc === ASIM ? 'Sim' : 'Não'}</TableCell>

                                            <TableCell align="center">
                                                <Tooltip
                                                    title="Remover"
                                                    enterdelay={50}
                                                >
                                                    <DeleteForeverOutlinedIcon
                                                        onMouseEnter={(e) => e.currentTarget.style.color = 'red'}
                                                        onMouseLeave={(e) => e.currentTarget.style.color = '#263238'}
                                                        onClick={() => this.handleOpenRemoveOpcional(opc.codopcionalveiculo)}
                                                        style={{
                                                            cursor: 'pointer',
                                                            color: '#263238'
                                                        }}
                                                    />
                                                </Tooltip>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>

                            <br />
                            <br />
                            <br />

                            <Box
                                style={{
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    gap: 10
                                }}
                            >
                                <Button
                                    name="salvar"
                                    color="primary"
                                    variant="contained"
                                    onClick={this.onClickSave}
                                    disabled={isView}
                                >
                                    Salvar
                                </Button>

                                <Button
                                    name="cancelar"
                                    variant="contained"
                                    onClick={this.onClickCancel}
                                    color="secondary"
                                >
                                    Cancelar
                                </Button>
                            </Box>
                        </CardContent>
                    </TabContainer>
                }

                {activeTab === 4 &&
                    <TabContainer>
                        <CardContent>
                            <Typography
                                component="h1"
                                variant="h3"
                            >
                                Veículo {veiculo.codveiculo}
                            </Typography>

                            <br />

                            <Box style={{ marginTop: '17px' }}>
                                <FormControl style={{ width: '45.5%', marginRight: '1rem' }}>
                                    <ComboPadrao
                                        name={'codseguradora'}
                                        label={'Seguradora'}
                                        value={veiculo.codseguradora}
                                        onChange={this.onChange}
                                        fieldId={'codfornecedor'}
                                        listItems={fornecedoresgeral}
                                        fieldDescription={'fantasia'}
                                    />
                                </FormControl>

                                <TextField
                                    label="Numero apólice"
                                    style={{ width: '28%' }}
                                    name="apoliceseguro"
                                    value={veiculo.apoliceseguro || ''}
                                    variant="outlined"
                                    onChange={this.onChange}
                                    disabled={isView}
                                    inputProps={{ maxLength: 50 }}
                                />
                            </Box>

                            <Box style={{ marginTop: '17px' }}>
                                <TextField
                                    inputProps={{ maxLength: 50 }}
                                    label="Início vigência"
                                    name="iniciovigenciaseguro"
                                    onChange={this.onChange}
                                    type="date"
                                    value={veiculo.iniciovigenciaseguro ? veiculo.iniciovigenciaseguro.substring(0, 10) : ''}
                                    variant="outlined"
                                    disabled={isView}
                                    style={{ marginRight: '1rem' }}
                                    InputLabelProps={{
                                        shrink: true,
                                        required: false
                                    }}
                                />

                                <TextField
                                    inputProps={{ maxLength: 50 }}
                                    label="Fim vigência"
                                    name="fimvigenciaseguro"
                                    onChange={this.onChange}
                                    type="date"
                                    value={veiculo.fimvigenciaseguro ? veiculo.fimvigenciaseguro.substring(0, 10) : ''}
                                    variant="outlined"
                                    disabled={isView}
                                    style={{ marginRight: '1rem' }}
                                    InputLabelProps={{
                                        shrink: true,
                                        required: false
                                    }}
                                />

                                <TextField
                                    label="Avisar dias antes do vencimento"
                                    name="avisovencsegurodias"
                                    value={veiculo.avisovencsegurodias || ''}
                                    variant="outlined"
                                    disabled={isView}
                                    type="number"
                                    style={{ width: '25%' }}
                                    inputProps={{ min: 1 }}
                                    onChange={(e) => {
                                        const valor = parseInt(e.target.value);
                                        if (valor >= 1 || e.target.value === '') {
                                            this.onChange(e);
                                        }
                                    }}
                                />
                            </Box>

                            <fieldset
                                style={{
                                    width: '75%',
                                    marginTop: '15px',
                                    padding: '15px',
                                    borderRadius: '5px',
                                    border: '1px solid #ccc'
                                }}
                            >
                                <legend
                                    style={{
                                        padding: '0 10px',
                                        fontFamily: 'Calibri, sans-serif',
                                        fontWeight: 'bold',
                                        color: '#808080'
                                    }}
                                >
                                    Valores
                                </legend>

                                <Box>
                                    <TextField
                                        label="Franquia"
                                        name="franquiaseguro"
                                        value={veiculo.franquiaseguro !== '' && veiculo.franquiaseguro !== null && veiculo.franquiaseguro !== undefined ? formatCurrency(veiculo.franquiaseguro) : '0,00'}
                                        variant="outlined"
                                        onChange={(e) => this.handleChangeValorMonetario(e, 'franquiaseguro')}
                                        disabled={isView}
                                        type="text"
                                        style={{
                                            width: '23%',
                                            marginRight: '1.5rem'
                                        }}
                                    />

                                    <TextField
                                        label="Danos materiais"
                                        name="danosmatseguro"
                                        value={veiculo.danosmatseguro !== '' && veiculo.danosmatseguro !== null && veiculo.danosmatseguro !== undefined ? formatCurrency(veiculo.danosmatseguro) : '0,00'}
                                        variant="outlined"
                                        onChange={(e) => this.handleChangeValorMonetario(e, 'danosmatseguro')}
                                        disabled={isView}
                                        type="text"
                                        style={{
                                            width: '23%',
                                            marginRight: '1rem'
                                        }}
                                    />

                                    <TextField
                                        label="Danos corporais"
                                        name="danoscorpseguro"
                                        value={veiculo.danoscorpseguro !== '' && veiculo.danoscorpseguro !== null && veiculo.danoscorpseguro !== undefined ? formatCurrency(veiculo.danoscorpseguro) : '0,00'}
                                        variant="outlined"
                                        onChange={(e) => this.handleChangeValorMonetario(e, 'danoscorpseguro')}
                                        disabled={isView}
                                        type="text"
                                        style={{
                                            width: '23%',
                                            marginRight: '1rem'
                                        }}
                                    />

                                    <TextField
                                        label="Danos morais"
                                        name="danosmoraisseguro"
                                        value={veiculo.danosmoraisseguro !== '' && veiculo.danosmoraisseguro !== null && veiculo.danosmoraisseguro !== undefined ? formatCurrency(veiculo.danosmoraisseguro) : '0,00'}
                                        variant="outlined"
                                        onChange={(e) => this.handleChangeValorMonetario(e, 'danosmoraisseguro')}
                                        disabled={isView}
                                        type="text"
                                        style={{ width: '23%' }}
                                    />
                                </Box>
                            </fieldset>

                            <Box
                                display="flex"
                                alignItems="center"
                                style={{ marginTop: '20px' }}
                            >
                                <input
                                    accept="*"
                                    style={{ display: 'none' }}
                                    id="btn-arquivo-ts"
                                    type="file"
                                    onChange={this.handleFileTS}
                                />

                                <TextField
                                    label="Local cópia documento - TS"
                                    variant="outlined"
                                    value={veiculo.localdocsegts || ''}
                                    disabled
                                    fullWidth
                                    style={{
                                        width: '47%',
                                        marginRight: '1rem'
                                    }}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <Tooltip
                                                    title="Buscar arquivo"
                                                    enterDelay={50}
                                                >
                                                    <IconButton
                                                        component="label"
                                                        disabled={!!(veiculo.arquivoTS || veiculo.localdocsegts)}
                                                        style={{ backgroundColor: 'transparent' }}
                                                        disableRipple
                                                        disableFocusRipple
                                                    >
                                                        <FolderOpenIcon
                                                            onMouseEnter={(e) => { if (!isUploadDisabledSegTS) e.currentTarget.style.color = '#1976d2'; }}
                                                            onMouseLeave={(e) => { if (!isUploadDisabledSegTS) e.currentTarget.style.color = '#546e7a'; }}
                                                            style={{ color: isUploadDisabledSegTS ? '#bdbdbd' : '#546e7a' }}
                                                        />

                                                        <input
                                                            type="file"
                                                            style={{ display: 'none' }}
                                                            onChange={this.handleFileTS}
                                                            disabled={isView}
                                                            ref={this.inputFileTSRef}
                                                        />
                                                    </IconButton>
                                                </Tooltip>

                                                <Tooltip
                                                    title="Remover"
                                                    enterDelay={50}
                                                >
                                                    <IconButton
                                                        onClick={this.handleOpenConfirmRemoveSeguroTS}
                                                        disabled={!(veiculo.arquivoTS || veiculo.localdocsegts)}
                                                        style={{ backgroundColor: 'transparent' }}
                                                        disableRipple
                                                        disableFocusRipple
                                                    >
                                                        <DeleteForeverOutlinedIcon
                                                            onMouseEnter={(e) => { if (!isDeleteDisabledSegTS) e.currentTarget.style.color = 'red'; }}
                                                            onMouseLeave={(e) => { if (!isDeleteDisabledSegTS) e.currentTarget.style.color = '#546e7a'; }}
                                                            style={{ color: isDeleteDisabledSegTS ? '#bdbdbd' : '#546e7a' }}
                                                        />
                                                    </IconButton>
                                                </Tooltip>
                                            </InputAdornment>
                                        )
                                    }}
                                />

                                <input
                                    accept="*"
                                    style={{ display: 'none' }}
                                    id="btn-arquivo-rede-interna"
                                    type="file"
                                    onChange={this.handleFileRedeInterna}
                                />

                                <TextField
                                    label="Local cópia documento - rede interna"
                                    variant="outlined"
                                    value={veiculo.localdocsegredeint || ''}
                                    disabled
                                    fullWidth
                                    style={{ width: '47.5%' }}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <Tooltip
                                                    title="Buscar arquivo"
                                                    enterDelay={50}
                                                >
                                                    <IconButton
                                                        component="label"
                                                        disabled={!!(veiculo.arquivoRedeInterna || veiculo.localdocsegredeint)}
                                                        style={{ backgroundColor: 'transparent' }}
                                                        disableRipple
                                                        disableFocusRipple
                                                    >
                                                        <FolderOpenIcon
                                                            onMouseEnter={(e) => { if (!isUploadDisabledSegRedeInterna) e.currentTarget.style.color = '#1976d2'; }}
                                                            onMouseLeave={(e) => { if (!isUploadDisabledSegRedeInterna) e.currentTarget.style.color = '#546e7a'; }}
                                                            style={{ color: isUploadDisabledSegRedeInterna ? '#bdbdbd' : '#546e7a' }}
                                                        />

                                                        <input
                                                            type="file"
                                                            style={{ display: 'none' }}
                                                            onChange={this.handleFileRedeInterna}
                                                            disabled={isView}
                                                            ref={this.inputFileRedeInternaRef}
                                                        />
                                                    </IconButton>
                                                </Tooltip>

                                                <Tooltip
                                                    title="Remover"
                                                    enterDelay={50}
                                                >
                                                    <IconButton
                                                        onClick={this.handleOpenConfirmRemoveSeguroRedeInterna}
                                                        disabled={!(veiculo.arquivoRedeInterna || veiculo.localdocsegredeint)}
                                                        style={{ backgroundColor: 'transparent' }}
                                                        disableRipple
                                                        disableFocusRipple
                                                    >
                                                        <DeleteForeverOutlinedIcon
                                                            onMouseEnter={(e) => { if (!isDeleteDisabledSegRedeInterna) e.currentTarget.style.color = 'red'; }}
                                                            onMouseLeave={(e) => { if (!isDeleteDisabledSegRedeInterna) e.currentTarget.style.color = '#546e7a'; }}
                                                            style={{ color: isDeleteDisabledSegRedeInterna ? '#bdbdbd' : '#546e7a' }}
                                                        />
                                                    </IconButton>
                                                </Tooltip>
                                            </InputAdornment>
                                        )
                                    }}
                                />
                            </Box>

                            <Box style={{ marginTop: '17px' }}>
                                <Typography
                                    color="textSecondary"
                                    component="p"
                                    variant="body2"
                                >
                                    Observação
                                </Typography>

                                <FormGroup>
                                    <textarea
                                        id="obsseguro"
                                        name="obsseguro"
                                        onChange={this.onChange}
                                        value={veiculo.obsseguro}
                                        disabled={isView}
                                        style={{
                                            width: '96%',
                                            height: '80px',
                                            padding: '8px',
                                            border: '1px solid #ccc',
                                            borderRadius: '4px',
                                            fontFamily: 'Calibri, sans-serif'
                                        }}
                                    />
                                </FormGroup>
                            </Box>

                            <br />
                            <br />
                            <br />

                            <Box
                                style={{
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    gap: 10
                                }}
                            >
                                <Button
                                    name="salvar"
                                    color="primary"
                                    variant="contained"
                                    onClick={this.onClickSave}
                                    disabled={isView}
                                >
                                    Salvar
                                </Button>

                                <Button
                                    name="cancelar"
                                    variant="contained"
                                    onClick={this.onClickCancel}
                                    color="secondary"
                                >
                                    Cancelar
                                </Button>
                            </Box>
                        </CardContent>
                    </TabContainer>
                }

                {activeTab === 5 &&
                    <TabContainer>
                        <CardContent>
                            <Box
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                            >
                                <Typography
                                    component="h1"
                                    variant="h3"
                                >
                                    Veículo {veiculo.codveiculo}
                                </Typography>
                            </Box>

                            <br />

                            <FormLabel
                                component="legend"
                                disabled={isView}
                                style={{
                                    textAlign: 'center',
                                    backgroundColor: '#e0e0e0',
                                    padding: '3px'
                                }}
                            >
                                Documentos de veículo
                            </FormLabel>

                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="center">Descrição</TableCell>

                                        <TableCell align="center">Vencimento</TableCell>

                                        <TableCell align="center">Inativo</TableCell>

                                        <TableCell align="center">Ações</TableCell>

                                        <TableCell align="center">
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    justifyContent: 'flex-end',
                                                    alignItems: 'center'
                                                }}
                                            >
                                                <Button
                                                    variant="outlined"
                                                    color="primary"
                                                    onClick={this.handleOpenModalDocumentos}
                                                    disabled={isView}
                                                    style={{
                                                        backgroundColor: colors.grey[300],
                                                        color: 'black',
                                                        padding: '4px 12px'
                                                    }}
                                                >
                                                    Inserir
                                                </Button>
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {documentosveiculo.map((doc, index) => (
                                        <TableRow key={index}>
                                            <TableCell align="center">{doc.descricao}</TableCell>

                                            <TableCell align="center">{formatData(doc.vencimento)}</TableCell>

                                            <TableCell align="center">{doc.inativodoc === ASIM ? 'Sim' : 'Não'}</TableCell>

                                            <TableCell align="center">
                                                <Tooltip
                                                    title="Alterar"
                                                    enterDelay={50}
                                                >
                                                    <EditTwoToneIcon
                                                        onMouseEnter={(e) => e.currentTarget.style.color = '#1976d2'}
                                                        onMouseLeave={(e) => e.currentTarget.style.color = '#263238'}
                                                        onClick={() => this.handleChangeDocumento(doc)}
                                                        style={{
                                                            cursor: 'pointer',
                                                            color: '#263238',
                                                            marginRight: 6
                                                        }}
                                                    />
                                                </Tooltip>

                                                <Tooltip
                                                    title="Excluir"
                                                    enterDelay={50}
                                                >
                                                    <DeleteForeverOutlinedIcon
                                                        onMouseEnter={(e) => e.currentTarget.style.color = 'red'}
                                                        onMouseLeave={(e) => e.currentTarget.style.color = '#263238'}
                                                        onClick={() => this.handleOpenDeleteDocumento(doc.chave)}
                                                        style={{
                                                            cursor: 'pointer',
                                                            color: '#263238'
                                                        }}
                                                    />
                                                </Tooltip>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>

                            <br />
                            <br />
                            <br />

                            <Box
                                style={{
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    gap: 10
                                }}
                            >
                                <Button
                                    name="salvar"
                                    color="primary"
                                    variant="contained"
                                    onClick={this.onClickSave}
                                    disabled={isView}
                                >
                                    Salvar
                                </Button>

                                <Button
                                    name="cancelar"
                                    variant="contained"
                                    onClick={this.onClickCancel}
                                    color="secondary"
                                >
                                    Cancelar
                                </Button>
                            </Box>
                        </CardContent>
                    </TabContainer>
                }

                {/* Modal documentos */}
                <Dialog
                    open={openModalDocumentos}
                    onClose={() => this.setState({ openModalDocumentos: false })}
                    maxWidth="sm"
                    fullWidth
                >
                    <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                    >
                        <DialogTitle>Documentos</DialogTitle>

                        <FormControlLabel
                            label={documento.inativodoc === ANAO ? 'Ativo' : 'Inativo'}
                            control={
                                <Switch
                                    checked={documento.inativodoc === ANAO}
                                    name="inativodoc"
                                    onChange={this.onChangeDocumento}
                                    color="primary"
                                    disabled={isView}
                                />
                            }
                        />
                    </Box>

                    <DialogContent>
                        <Box style={{ marginTop: '10px' }}>
                            <TextField
                                label="Veículo"
                                name="nroveiculo"
                                value={veiculo.nroveiculo || ''}
                                variant="outlined"
                                onChange={this.onChange}
                                disabled={isView}
                                inputProps={{ maxLength: 50 }}
                                InputProps={{
                                    readOnly: true,
                                    style: {
                                        color: 'rgba(0, 0, 0, 0.5)',
                                        backgroundColor: '#f5f5f5',
                                        pointerEvents: 'none'
                                    }
                                }}
                                style={{
                                    width: '96%',
                                    backgroundColor: 'transparent'
                                }}
                            />
                        </Box>

                        <TextField
                            label="Descrição"
                            name="descricao"
                            value={documento.descricao || ''}
                            variant="outlined"
                            onChange={this.onChangeDocumento}
                            helperText={errors.descricao || ''}
                            error={!!errors.descricao}
                            disabled={isView}
                            inputProps={{ maxLength: 50 }}
                            style={{
                                marginTop: '15px',
                                width: '96%'
                            }}
                        />

                        <Box style={{ marginTop: '17px' }}>
                            <TextField
                                inputProps={{ maxLength: 50 }}
                                label="Vencimento"
                                name="vencimento"
                                onChange={this.onChangeDocumento}
                                type="date"
                                value={documento.vencimento ? documento.vencimento.substring(0, 10) : ''}
                                variant="outlined"
                                disabled={isView}
                                InputLabelProps={{
                                    shrink: true,
                                    required: false
                                }}
                                style={{
                                    width: '35%',
                                    marginRight: '1rem'
                                }}
                            />

                            <TextField
                                label="Avisar dias antes do vencimento"
                                name="avisodiasantecedencia"
                                value={documento.avisodiasantecedencia || ''}
                                variant="outlined"
                                disabled={isView}
                                type="number"
                                style={{ width: '58.2%' }}
                                inputProps={{ min: 1 }}
                                onChange={(e) => {
                                    const valor = parseInt(e.target.value);
                                    if (valor >= 1 || e.target.value === '') {
                                        this.onChangeDocumento(e);
                                    }
                                }}
                            />
                        </Box>

                        <Box style={{ marginTop: '15px' }}>
                            <input
                                accept="*"
                                style={{ display: 'none' }}
                                id="btn-arquivo-ts"
                                type="file"
                                onChange={this.handleFileDocumentoTS}
                            />

                            <TextField
                                label="Local arquivo - TS"
                                variant="outlined"
                                value={documento.localdocts || ''}
                                disabled
                                fullWidth
                                style={{ width: '96%' }}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <Tooltip
                                                title="Buscar arquivo"
                                                enterDelay={50}
                                            >
                                                <IconButton
                                                    component="label"
                                                    disabled={!!(documento.arquivoTS || documento.localdocts)}
                                                    style={{ backgroundColor: 'transparent' }}
                                                    disableRipple
                                                    disableFocusRipple
                                                >
                                                    <FolderOpenIcon
                                                        onMouseEnter={(e) => { if (!isUploadDisabledTS) e.currentTarget.style.color = '#1976d2'; }}
                                                        onMouseLeave={(e) => { if (!isUploadDisabledTS) e.currentTarget.style.color = '#546e7a'; }}
                                                        style={{ color: isUploadDisabledTS ? '#bdbdbd' : '#546e7a' }}
                                                    />

                                                    <input
                                                        type="file"
                                                        style={{ display: 'none' }}
                                                        onChange={this.handleFileDocumentoTS}
                                                        disabled={isView}
                                                        ref={this.inputFileTSRef}
                                                    />
                                                </IconButton>
                                            </Tooltip>

                                            <Tooltip
                                                title="Remover"
                                                enterDelay={50}
                                            >
                                                <IconButton
                                                    onClick={this.handleOpenConfirmRemoveDocumentoTS}
                                                    disabled={!(documento.arquivoTS || documento.localdocts)}
                                                    style={{ backgroundColor: 'transparent' }}
                                                    disableRipple
                                                    disableFocusRipple
                                                >
                                                    <DeleteForeverOutlinedIcon
                                                        onMouseEnter={(e) => { if (!isDeleteDisabledTS) e.currentTarget.style.color = 'red'; }}
                                                        onMouseLeave={(e) => { if (!isDeleteDisabledTS) e.currentTarget.style.color = '#546e7a'; }}
                                                        style={{ color: isDeleteDisabledTS ? '#bdbdbd' : '#546e7a' }}
                                                    />
                                                </IconButton>
                                            </Tooltip>
                                        </InputAdornment>
                                    )
                                }}
                            />
                        </Box>

                        <Box style={{ marginTop: '15px' }}>
                            <input
                                accept="*"
                                style={{ display: 'none' }}
                                id="btn-arquivo-rede-interna"
                                type="file"
                                onChange={this.handleFileDocumentoRedeInterna}
                            />

                            <TextField
                                label="Local arquivo - rede interna"
                                variant="outlined"
                                value={documento.localdocredeint || ''}
                                disabled
                                fullWidth
                                style={{ width: '96%' }}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <Tooltip
                                                title="Buscar arquivo"
                                                enterDelay={50}
                                            >
                                                <IconButton
                                                    component="label"
                                                    disabled={!!(documento.arquivoRedeInterna || documento.localdocredeint)}
                                                    style={{ backgroundColor: 'transparent' }}
                                                    disableRipple
                                                    disableFocusRipple
                                                >
                                                    <FolderOpenIcon
                                                        onMouseEnter={(e) => { if (!isUploadDisabledRedeInterna) e.currentTarget.style.color = '#1976d2'; }}
                                                        onMouseLeave={(e) => { if (!isUploadDisabledRedeInterna) e.currentTarget.style.color = '#546e7a'; }}
                                                        style={{ color: isUploadDisabledRedeInterna ? '#bdbdbd' : '#546e7a' }}
                                                    />

                                                    <input
                                                        type="file"
                                                        style={{ display: 'none' }}
                                                        onChange={this.handleFileDocumentoRedeInterna}
                                                        disabled={isView}
                                                        ref={this.inputFileRedeInternaRef}
                                                    />
                                                </IconButton>
                                            </Tooltip>

                                            <Tooltip
                                                title="Remover"
                                                enterDelay={50}
                                            >
                                                <IconButton
                                                    onClick={this.handleOpenConfirmRemoveDocumentoRedeInterna}
                                                    disabled={!(documento.arquivoRedeInterna || documento.localdocredeint)}
                                                    style={{ backgroundColor: 'transparent' }}
                                                    disableRipple
                                                    disableFocusRipple
                                                >
                                                    <DeleteForeverOutlinedIcon
                                                        onMouseEnter={(e) => { if (!isDeleteDisabledRedeInterna) e.currentTarget.style.color = 'red'; }}
                                                        onMouseLeave={(e) => { if (!isDeleteDisabledRedeInterna) e.currentTarget.style.color = '#546e7a'; }}
                                                        style={{ color: isDeleteDisabledRedeInterna ? '#bdbdbd' : '#546e7a' }}
                                                    />
                                                </IconButton>
                                            </Tooltip>
                                        </InputAdornment>
                                    )
                                }}
                            />
                        </Box>

                        <Box style={{ marginTop: '15px' }}>
                            <Typography
                                color="textSecondary"
                                component="p"
                                variant="body2"
                            >
                                Descritivo
                            </Typography>

                            <FormGroup>
                                <textarea
                                    id="descritivodoc"
                                    name="descritivodoc"
                                    onChange={this.onChangeDocumento}
                                    value={documento.descritivodoc}
                                    disabled={isView}
                                    style={{
                                        width: '96%',
                                        height: '80px',
                                        padding: '8px',
                                        border: '1px solid #ccc',
                                        borderRadius: '4px',
                                        fontFamily: 'Calibri, sans-serif'
                                    }}
                                />
                            </FormGroup>
                        </Box>
                    </DialogContent>

                    <DialogActions>
                        <Button
                            onClick={() => this.setState({ openModalDocumentos: false })}
                            color="secondary"
                        >
                            Cancelar
                        </Button>

                        <Button
                            onClick={this.onClickSaveDocumento}
                            color="primary"
                        >
                            Salvar
                        </Button>
                    </DialogActions>
                </Dialog>

                {/* Modal opcionais */}
                <Dialog
                    open={openModalOpcionais}
                    onClose={this.handleCloseModalOpcionais}
                    maxWidth="sm"
                    fullWidth
                >
                    <DialogTitle>Opcionais de veículo</DialogTitle>

                    <DialogContent>
                        <FormControl fullWidth>
                            <ComboPadrao
                                name="codopcionalveiculo"
                                label="Opcional"
                                value={opcional.codopcionalveiculo}
                                onChange={this.onChangeOpcional}
                                fieldId="codopcionalveiculo"
                                listItems={opcionais}
                                fieldDescription="descopcionalveiculo"
                            />
                        </FormControl>
                    </DialogContent>

                    <DialogActions style={{ justifyContent: 'space-between', px: 3 }}>
                        <Box style={{ display: 'flex', gap: 1 }}>
                            <Tooltip
                                title="Cadastrar"
                                enterdelay={50}
                            >
                                <IconButton
                                    onClick={this.handleOpenModalTwo}
                                    style={{ backgroundColor: 'transparent' }}
                                    disableRipple
                                    disableFocusRipple
                                >
                                    <PostAddIcon
                                        onMouseEnter={(e) => e.currentTarget.style.color = '#1976d2'}
                                        onMouseLeave={(e) => e.currentTarget.style.color = '#546e7a'}
                                        style={{
                                            cursor: 'pointer',
                                            color: '#546e7a'
                                        }}
                                    />
                                </IconButton>
                            </Tooltip>

                            <Tooltip
                                title="Alterar"
                                enterdelay={50}
                            >
                                <IconButton
                                    onClick={() => this.handleOpenModalOne(false)}
                                    style={{ backgroundColor: 'transparent' }}
                                    disableRipple
                                    disableFocusRipple
                                >
                                    <EditTwoToneIcon
                                        onMouseEnter={(e) => e.currentTarget.style.color = '#1976d2'}
                                        onMouseLeave={(e) => e.currentTarget.style.color = '#546e7a'}
                                        style={{
                                            cursor: 'pointer',
                                            color: '#546e7a'
                                        }}
                                    />
                                </IconButton>
                            </Tooltip>

                            <Tooltip
                                title="Visualizar"
                                enterdelay={50}
                            >
                                <IconButton
                                    onClick={() => this.handleOpenModalOne(true)}
                                    style={{ backgroundColor: 'transparent' }}
                                    disableRipple
                                    disableFocusRipple
                                >
                                    <VisibilityOutlinedIcon
                                        onMouseEnter={(e) => e.currentTarget.style.color = '#1976d2'}
                                        onMouseLeave={(e) => e.currentTarget.style.color = '#546e7a'}
                                        style={{
                                            cursor: 'pointer',
                                            color: '#546e7a'
                                        }}
                                    />
                                </IconButton>
                            </Tooltip>

                            <Tooltip
                                title="Excluir"
                                enterdelay={50}
                            >
                                <IconButton
                                    onClick={this.handleOpenDeleteOpcional}
                                    style={{ backgroundColor: 'transparent' }}
                                    disableRipple
                                    disableFocusRipple
                                >
                                    <DeleteForeverOutlinedIcon
                                        onMouseEnter={(e) => e.currentTarget.style.color = 'red'}
                                        onMouseLeave={(e) => e.currentTarget.style.color = '#546e7a'}
                                        style={{
                                            cursor: 'pointer',
                                            color: '#546e7a'
                                        }}
                                    />
                                </IconButton>
                            </Tooltip>
                        </Box>

                        <Box>
                            <Button
                                onClick={this.handleInsertOpcional}
                                color="primary"
                            >
                                Selecionar
                            </Button>

                            <Button
                                onClick={this.handleCloseModalOpcionais}
                                color="default"
                            >
                                Fechar
                            </Button>
                        </Box>
                    </DialogActions>
                </Dialog>

                {/* Modal edição/visualização opcionais */}
                <Dialog
                    open={openModalOne}
                    onClose={this.handleCloseModalOne}
                    maxWidth="sm"
                    fullWidth
                >
                    <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                    >
                        <DialogTitle>Opcional de veículo</DialogTitle>

                        <FormControlLabel
                            label={opcional.inativoopc === ANAO ? 'Ativo' : 'Inativo'}
                            control={
                                <Switch
                                    checked={opcional.inativoopc === ANAO}
                                    name="inativoopc"
                                    onChange={this.onChangeOpcional}
                                    color="primary"
                                    disabled={isView}
                                />
                            }
                        />
                    </Box>

                    <DialogContent>
                        <Box
                            display="flex"
                            gap={2}
                            style={{ marginTop: '15px' }}
                        >
                            <TextField
                                label="Código"
                                name="codopcionalveiculo"
                                value={opcional.codopcionalveiculo || ''}
                                variant="outlined"
                                onChange={this.onChangeOpcional}
                                disabled={isView}
                                InputProps={{
                                    readOnly: true,
                                    style: {
                                        color: 'rgba(0, 0, 0, 0.5)',
                                        backgroundColor: '#f5f5f5',
                                        pointerEvents: 'none'
                                    }
                                }}
                                style={{
                                    width: '20%',
                                    marginRight: '0.5rem',
                                    backgroundColor: 'transparent'
                                }}
                            />

                            <TextField
                                label="Descrição"
                                style={{ width: '80%' }}
                                name="descopcionalveiculo"
                                value={opcional.descopcionalveiculo || ''}
                                variant="outlined"
                                onChange={this.onChangeOpcional}
                                error={!!errors.descopcionalveiculo}
                                helperText={errors.descopcionalveiculo || ''}
                                disabled={isView}
                                inputProps={{ maxLength: 50 }}
                            />
                        </Box>
                    </DialogContent>

                    <DialogActions>
                        <Button
                            onClick={this.handleCloseModalOne}
                            color="default"
                        >
                            Cancelar
                        </Button>

                        <Button
                            onClick={this.onClickSaveOpcional}
                            color="primary"
                            disabled={isView}
                        >
                            Salvar
                        </Button>
                    </DialogActions>
                </Dialog>

                {/* Modal cadastro opcionais */}
                <Dialog
                    open={openModalTwo}
                    onClose={this.handleCloseModalTwo}
                    maxWidth="sm"
                    fullWidth
                >
                    <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                    >
                        <DialogTitle>Opcional de veículo</DialogTitle>

                        <FormControlLabel
                            label={opcional.inativoopc === ANAO ? 'Ativo' : 'Inativo'}
                            control={
                                <Switch
                                    checked={opcional.inativoopc === ANAO}
                                    name="inativoopc"
                                    onChange={this.onChangeOpcional}
                                    color="primary"
                                    disabled={isView}
                                />
                            }
                        />
                    </Box>

                    <DialogContent>
                        <TextField
                            label="Descrição"
                            name="descopcionalveiculo"
                            value={opcional.descopcionalveiculo || ''}
                            variant="outlined"
                            onChange={this.onChangeOpcional}
                            error={!!errors.descopcionalveiculo}
                            helperText={errors.descopcionalveiculo || ''}
                            disabled={isView}
                            inputProps={{ maxLength: 50 }}
                            style={{
                                marginTop: '15px',
                                width: '100%'
                            }}
                        />
                    </DialogContent>

                    <DialogActions>
                        <Button
                            onClick={this.handleCloseModalTwo}
                            color="default"
                        >
                            Cancelar
                        </Button>

                        <Button
                            onClick={this.onClickSaveOpcional}
                            color="primary"
                            disabled={isView}
                        >
                            Salvar
                        </Button>
                    </DialogActions>
                </Dialog>

                <DeleteConfirmationModal
                    open={openConfirmDeleteDocumento}
                    handleClose={this.handleCloseDeleteDocumento}
                    itemId={documentoASerExcluido}
                    message={"Confirma exclusão do documento selecionado?"}
                    handleDelete={this.handleConfirmDeleteDocumento}
                />

                <DeleteConfirmationModal
                    open={openConfirmDeleteOpcional}
                    handleClose={this.handleCloseDeleteOpcional}
                    itemId={opcionalASerExcluido}
                    message={"Confirma exclusão do opcional selecionado?"}
                    handleDelete={this.handleConfirmDeleteOpcional}
                />

                <DeleteConfirmationModal
                    open={openConfirmRemoveOpcional}
                    handleClose={this.handleCloseRemoveOpcional}
                    itemId={opcionalASerRemovido}
                    message={"Deseja realmente remover da grid o opcional selecionado?"}
                    handleDelete={this.handleConfirmRemoveOpcional}
                />

                <DeleteConfirmationModal
                    open={openConfirmRemoveSeguroTS}
                    handleClose={this.handleCloseConfirmRemoveSeguroTS}
                    itemId=""
                    message={"Confirma remoção do arquivo TS?"}
                    handleDelete={() => {
                        this.handleCloseConfirmRemoveSeguroTS();
                        this.handleDeleteFileTS();
                    }}
                />

                <DeleteConfirmationModal
                    open={openConfirmRemoveSeguroRedeInterna}
                    handleClose={this.handleCloseConfirmRemoveSeguroRedeInterna}
                    itemId=""
                    message={"Confirma remoção do arquivo de rede interna?"}
                    handleDelete={() => {
                        this.handleCloseConfirmRemoveSeguroRedeInterna();
                        this.handleDeleteFileRedeInterna();
                    }}
                />

                <DeleteConfirmationModal
                    open={openConfirmRemoveDocumentoTS}
                    handleClose={this.handleCloseConfirmRemoveDocumentoTS}
                    itemId=""
                    message={"Confirma remoção do arquivo TS?"}
                    handleDelete={() => {
                        this.handleCloseConfirmRemoveDocumentoTS();
                        this.handleDeleteFileDocumentoTS();
                    }}
                />

                <DeleteConfirmationModal
                    open={openConfirmRemoveDocumentoRedeInterna}
                    handleClose={this.handleCloseConfirmRemoveDocumentoRedeInterna}
                    itemId=""
                    message={"Confirma remoção do arquivo de rede interna?"}
                    handleDelete={() => {
                        this.handleCloseConfirmRemoveDocumentoRedeInterna();
                        this.handleDeleteFileDocumentoRedeInterna();
                    }}
                />

                <AlertInformation
                    open={openAlert}
                    handleClose={() => this.handleCloseAlert()}
                    message={messageAlert}
                />
            </div >
        );
    }
}

export default VeiculoForm;